import { Autocomplete } from "@mui/material";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Tooltip } from '@mui/material';
import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../withRouter.js";
import { ccountry, currentTenant, userid } from "../Common/Credentials.js";
import InventoryService from "../inventory/InventoryService.js";
import CategoryServices from "../Masters/Category/CategoryServices.js";
import UomServices from "../Masters/Uom/UomServices.js"
import MasterService from "../Masters/MasterService.js";
import SettingsServices from "../Settings/SettingsServices.js";
import BrandsServices from "../Masters/Brands/BrandsServices.js";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import { appmasterid } from "../Common/Permissions.js";
import { SelectableRadio } from "../NewUI/NewComponents/SelectableRadio.jsx";
import EditIcon from "../images/Icons/edit.png";
import DeleteIcon from "../images/Icons/delete.png";
import Breadcrumb from "../NewUI/NewComponents/Breadcrumb.jsx";
import { toast } from "../NewUI/NewComponents/toastService.js";
import TextfieldComponent from "../Component/TextfieldComponent.jsx";
import TextareaField from "../NewUI/NewComponents/TextareaField.jsx";

class NewItem extends Component {

    constructor(props) {
        super(props);
        const { pagename, id } = this.props.location.state;

        this.state = {
            hovered: null,
            addNewDialogOpen: false,
            addNewDialogOpenSub: false,
            addNewDialogOpenLevel3: false,
            newMainCategory: "",
            newSubCategory: "",
            newCategoryName: "",
            saveLoading: false,
            addNewMessage: "",

            // Form state
            tenantid: currentTenant,
            formSubmitted: false,
            errors: {},

            hsnloader: false,
            loader: false,
            pagename: pagename,
            id: id,
            itemname: "",
            hsn: "",
            HsnList: [],
            CategoryList: [],
            category: "",
            catid: '',
            CategoryList2: [],
            category2: "",
            catid2: '',
            mCategoryList: [],
            mcategory: "",
            mcatid: '',
            categorytype: '',
            code: "",
            hsnid: "",
            itemcode: '',
            status: "0",
            istatus: "1",
            message: "",
            success: '',
            uomid: "",
            uom: "",
            UOMList: [],
            ledger: "",
            ledgerid: '',
            ledgerlist: [],
            tax: '',
            additionalparamsforitem: 'NO',
            parameters: false,
            description: '',
            brandsList: [],
            brand: '',
            brandid: '',
            model: '',
            entrytype: 'manual',
            itemslist: [],
            iseditable: true,

            uploadedFiles: [],
            bulkEditItemId: null,
            bulkFieldMappings: {
                mcategory: '',
                mcatid: '',
                category2: '',
                catid2: '',
                category: '',
                catid: '',
                uom: '',
                uomid: '',
                brand: '',
                brandid: '',
                parameters: false
            },
            editingItem: null,

            // Brand & UOM dialog states
            addNewBrandDialogOpen: false,
            addNewUomDialogOpen: false,
            newBrandName: "",
            newUomName: "",
            newUomDescription: "",
            addNewMessageBrand: "",
            addNewMessageUom: "",
            saveLoadingBrand: false,
            saveLoadingUom: false,

            duplicateItemCodes: [],
            fileUploadLoading: false,
            fileUploadProgress: 0,
            validationErrors: {},
            mappingErrors: [],
            showValidationSummary: false,

            selectedItems: [],
            selectAll: false,

            editSubCategoryList: [],
            editLevel3CategoryList: [],

            submissionProgress: 0,
            submissionStatus: '',

            // Filter and Search states
            searchFilter: '',
            showOnlyErrors: false,
            showValidData: false,

            // Dialog parent category tracking
            dialogParentMainCategory: '',
            dialogParentSubCategory: '',
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.validate = this.validate.bind(this);
    }

    validate = () => {
        const errors = {};

        // if (this.state.id < 1) {
            if (this.state.entrytype === "manual") {
                if (!this.state.itemname || this.state.itemname.trim() === "") {
                    errors.itemname = "Item Name is required";
                }
                if (this.state.success === false) {
                    errors.itemname = "Item already exists!";
                }
                if (!this.state.itemcode || this.state.itemcode.trim() === "") {
                    errors.itemcode = "Please Enter Item Code";
                }
                if (!this.state.uomid || this.state.uomid === "") {
                    errors.uom = "Unit of Measurement is required";
                }
                if (!this.state.description || this.state.description.trim() === "" || this.state.description.length < 3) {
                    errors.description = "Please Enter minimum 3 Letters";
                }
            }

            if (!this.state.mcategory || this.state.mcategory === "") {
                errors.mcategory = "Main Category is required";
            }
            if (this.state.CategoryList2.length !== 0) {
                if (!this.state.category2 || this.state.category2 === "") {
                    errors.category2 = "Sub Category is required";
                }
            }
            if (this.state.CategoryList.length !== 0) {
                if (!this.state.category || this.state.category === "") {
                    errors.category = "Category Level 3 is required";
                }
            }
        // }

        return errors;
    };

    prepareItemObject = (itemData, type = 'manual') => {
        const currentTenantLocal = currentTenant;
        const userIdLocal = userid;

        if (type === 'manual') {
            const isUpdate = itemData.id > 0;
            return {
                ...(isUpdate ? { id: itemData.id, updatedby: userIdLocal } : { createdby: userIdLocal }),
                name: itemData.itemname,
                itemcode: itemData.itemcode,
                hsn: isUpdate ? itemData.hsnid : (itemData.hsn || ""),
                tenantid: currentTenantLocal,
                uomid: itemData.uomid,
                mcategory: itemData.mcategory,
                catidlvl2: itemData.catid2 === "" || itemData.catid2 === undefined ? 0 : itemData.catid2,
                mcatid: itemData.mcatid,
                tax: itemData.tax || 0,
                categorytype: itemData.categorytype,
                parameters: itemData.parameters ? 1 : 0,
                description: itemData.description,
                brand: itemData.brandid,
                model: itemData.model || "NA",
                categorylvl2: itemData.category2,
                category: itemData.category,
                catid: itemData.catid === "" || itemData.catid === undefined ? 0 : itemData.catid,
            };
        } else {
            const uomName = itemData.uom || this.state.bulkFieldMappings.uom || "";
            const brandName = itemData.brand || this.state.bulkFieldMappings.brand || "";
            const mCatName = itemData.mcategory || this.state.bulkFieldMappings.mcategory || "";
            const subCatName = itemData.category2 || this.state.bulkFieldMappings.category2 || "";
            const lvl3CatName = itemData.category || this.state.bulkFieldMappings.category || "";

            const uom = this.state.UOMList.find(u => u.name.toLowerCase() === uomName.toLowerCase());
            const brand = this.state.brandsList.find(b => b.brand.toLowerCase() === brandName.toLowerCase());
            const mainCategory = this.state.mCategoryList.find(cat => cat.category.toLowerCase() === mCatName.toLowerCase());

            let subCategory = null;
            if (mainCategory?.categorylvltwo) {
                subCategory = mainCategory.categorylvltwo.find(sub => sub.name.toLowerCase() === subCatName.toLowerCase());
            }

            let level3Category = null;
            if (subCategory?.category) {
                level3Category = subCategory.category.find(lvl3 => lvl3.category.toLowerCase() === lvl3CatName.toLowerCase());
            }

            return {
                name: itemData.name,
                itemcode: itemData.itemcode,
                hsn: itemData.hsn || "",
                createdby: userIdLocal,
                tenantid: currentTenantLocal,
                uomid: uom?.id || (uomName === this.state.bulkFieldMappings.uom ? this.state.bulkFieldMappings.uomid : itemData.uomid) || "",
                brand: brand?.id || (brandName === this.state.bulkFieldMappings.brand ? this.state.bulkFieldMappings.brandid : itemData.brandid) || "",
                model: itemData.model || "NA",
                catid: level3Category?.id || (lvl3CatName === this.state.bulkFieldMappings.category ? this.state.bulkFieldMappings.catid : itemData.catid) || 0,
                category: lvl3CatName,
                categorylvl2: subCatName,
                mcategory: mCatName,
                catidlvl2: subCategory?.id || (subCatName === this.state.bulkFieldMappings.category2 ? this.state.bulkFieldMappings.catid2 : itemData.catid2) || 0,
                mcatid: mainCategory?.id || (mCatName === this.state.bulkFieldMappings.mcategory ? this.state.bulkFieldMappings.mcatid : itemData.mcatid) || 0,
                tax: itemData.tax || 0,
                categorytype: mainCategory?.categorytype || itemData.categorytype || this.state.categorytype,
                parameters: (itemData.parameters !== undefined ? itemData.parameters : this.state.bulkFieldMappings.parameters) ? 1 : 0,
                description: itemData.description,
                _sourceId: itemData.id
            };
        }
    };

    getFilteredItems = () => {
        const { itemslist, searchFilter, showOnlyErrors, validationErrors, duplicateItemCodes, showValidData } = this.state;

        return itemslist.filter(item => {
            const matchesSearch = !searchFilter ||
                item.name.toLowerCase().includes(searchFilter.toLowerCase()) ||
                item.itemcode.toLowerCase().includes(searchFilter.toLowerCase());

            const hasError = validationErrors[item.id] || duplicateItemCodes.includes(item.itemcode);
            const matchesErrorFilter = !showOnlyErrors || hasError;
            const matchesValidFilter = !showValidData || !hasError;

            return matchesSearch && matchesErrorFilter && matchesValidFilter;
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        if (this.state.entrytype === "manual") {
            const errors = this.validate();
            this.setState({
                errors,
                formSubmitted: true
            });

            if (Object.keys(errors).length === 0) {
                this.onSubmit();
            } else {
                // Swal.fire({
                //     title: "Validation Error",
                //     text: "Please fill all required fields correctly",
                //     icon: "error",
                //     confirmButtonText: "Ok",
                //     confirmButtonColor: "#1976d2",
                // });
                toast("Please fill all required fields correctly","error");
            }
        } else {
            this.setState({
                formSubmitted: true,
                showValidationSummary: true
            }, () => {
                this.showConfirmationDialog();
            });
        }
    };

    showConfirmationDialog = () => {
        this.validateBulkItems();

        const itemsCount = this.state.itemslist.length;
        const selectedCount = this.state.selectedItems.length;
        const itemsToShow = selectedCount > 0 ?
            this.state.itemslist.filter(item => this.state.selectedItems.includes(item.id)) :
            this.state.itemslist;

        const displayCount = selectedCount > 0 ? selectedCount : itemsCount;

        const validationSummary = this.getValidationSummary();

        const tableRows = itemsToShow.map(item => {
            const errors = this.state.validationErrors[item.id];
            const isDuplicate = this.state.duplicateItemCodes.includes(item.itemcode);
            const hasIssue = errors || isDuplicate;

            return `
      <tr style="${hasIssue ? 'background-color: #fef2f2;' : 'background-color: #f0fdf4;'}">
        <td style="border: 1px solid #ddd; padding: 8px; font-weight: 600; color: ${hasIssue ? '#dc2626' : '#16a34a'};">
            ${hasIssue ? '✕ Error' : '✓ Ready'}
            ${errors ? `<div style="font-size: 0.7rem; font-weight: 400; color: #7f1d1d; margin-top: 2px;">${errors.join(', ')}</div>` : ''}
            ${isDuplicate ? `<div style="font-size: 0.7rem; font-weight: 400; color: #7f1d1d; margin-top: 2px;">Duplicate Code</div>` : ''}
        </td>
        <td style="border: 1px solid #ddd; padding: 8px;">${item.name}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">${item.itemcode}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">${item.hsn || '-'}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">${item.tax || '0'}%</td>
        <td style="border: 1px solid #ddd; padding: 8px;">${item.model || '-'}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">${item.mcategory || '-'}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">${item.category2 || '-'}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">${item.category || '-'}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">${item.uom || '-'}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">${item.brand || '-'}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">${item.parameters ? 'Yes' : 'No'}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">${item.description ? item.description.substring(0, 30) + (item.description.length > 30 ? '...' : '') : '-'}</td>
      </tr>
    `;
        }).join('');

        const moreItems = '';

        let validationHTML = '';
        if (validationSummary.hasErrors) {
            validationHTML = `
        <div style="background-color: #fef2f2; border: 1px solid #fecaca; border-radius: 6px; padding: 12px; margin: 10px 0;">
          <div style="color: #dc2626; font-weight: 600; margin-bottom: 8px; display: flex; align-items: center; gap: 6px;">
            ⚠ Validation Issues Found
          </div>
          <div style="font-size: 0.85rem; color: #7f1d1d;">
            ${validationSummary.message}
          </div>
        </div>
      `;
        }

        const tableHTML = `
      <div style="text-align: left; max-height: 400px; overflow-y: auto; padding: 10px 0;">
        ${validationHTML}
        <table style="width: 100%; border-collapse: collapse; font-size: 0.8rem;">
          <thead>
            <tr>
              <th style="border: 1px solid #ddd; padding: 8px; background-color: #e2e8f0; width: 120px;">Status</th>
              <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">Item Name</th>
              <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">Item Code</th>
              <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">HSN</th>
              <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">Tax</th>
              <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">Model</th>
              <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">Main Category</th>
              <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">Sub Category</th>
              <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">Category L3</th>
              <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">UOM</th>
              <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">Brand</th>
              <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">Params</th>
              <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">Description</th>
            </tr>
          </thead>
          <tbody>
            ${tableRows}
            ${moreItems}
          </tbody>
        </table>
      </div>
    `;

        const validItems = itemsToShow.filter(item =>
            !this.state.validationErrors[item.id] &&
            !this.state.duplicateItemCodes.includes(item.itemcode)
        );
        const invalidCount = displayCount - validItems.length;

        Swal.fire({
            title: validationSummary.hasErrors ? "Validation Issues Found" : `Confirm ${displayCount} ${displayCount === 1 ? 'Item' : 'Items'}?`,
            html: `
                <div style="margin-bottom: 10px; font-size: 0.9rem;">
                    ${validationSummary.hasErrors ?
                    `<span style="color: #dc2626; font-weight: 600;">${invalidCount} ${invalidCount === 1 ? 'item has' : 'items have'} issues</span> and <span style="color: #16a34a; font-weight: 600;">${validItems.length} ${validItems.length === 1 ? 'item is' : 'items are'} valid</span>.` :
                    `Ready to save ${displayCount} ${displayCount === 1 ? 'item' : 'items'}.`
                }
                </div>
                ${tableHTML}
                ${(this.state.bulkFieldMappings.mcategory && this.state.bulkFieldMappings.uom) && Object.keys(this.state.validationErrors).length > 0 ? `
                   <div style="margin-top: 15px; padding: 10px; background: #fffbeb; border-radius: 6px; border: 1px solid #fef3c7; display: flex; align-items: center; justify-content: space-between;">
                     <div style="text-align: left;">
                       <strong style="color: #92400e; font-size: 0.85rem;">Smart Fix Available</strong>
                       <div style="color: #92400e; font-size: 0.75rem;">Global values can be added to missing fields.</div>
                     </div>
                     <button id="smart-fix-btn" style="background: #f59e0b; color: white; border: none; padding: 6px 12px; border-radius: 4px; font-weight: 600; cursor: pointer; font-size: 0.8rem;">
                       Apply Smart Fix
                     </button>
                   </div>
                ` : ''}
            `,
            icon: validationSummary.hasErrors ? "warning" : "question",
            showCancelButton: true,
            showConfirmButton: displayCount > 0,
            confirmButtonText: validationSummary.hasErrors ?
                (validItems.length > 0 ? `Save ${validItems.length} Valid ${validItems.length === 1 ? 'Item' : 'Items'}` : "Fix Issues to Proceed") :
                `Confirm ${displayCount} ${displayCount === 1 ? 'Item' : 'Items'}`,
            confirmButtonColor: validationSummary.hasErrors ? "#f59e0b" : "#1976d2",
            cancelButtonText: "Cancel",
            width: 1200,
            didOpen: () => {
                const smartFixBtn = document.getElementById('smart-fix-btn');
                if (smartFixBtn) {
                    smartFixBtn.addEventListener('click', () => {
                        this.applyAllMappings(true);
                        Swal.close();
                        // Re-open dialog after state update
                        setTimeout(() => this.showConfirmationDialog(), 300);
                    });
                }
            },
            footer: validationSummary.hasErrors ?
                `<div style="color: #dc2626; font-weight: 600;">Invalid ${invalidCount === 1 ? 'item' : 'items'} will remain in the list for you to fix.</div>` :
                '',
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                if (validationSummary.hasErrors && validItems.length === 0) {
                    return;
                }
                this.submitBulkItems(validItems);
            }
        });
    }

    getValidationSummary = () => {
        const hasDuplicates = this.state.duplicateItemCodes.length > 0;
        const hasValidationErrors = Object.keys(this.state.validationErrors).length > 0;
        const hasMappingErrors = this.state.mappingErrors.length > 0;

        if (!hasDuplicates && !hasValidationErrors && !hasMappingErrors) {
            return { hasErrors: false, message: "All items are valid and ready for submission." };
        }

        let messages = [];

        if (hasDuplicates) {
            const dupCount = this.state.duplicateItemCodes.length;
            messages.push(`${dupCount} duplicate item code${dupCount !== 1 ? 's' : ''} found`);
        }

        if (hasValidationErrors) {
            const errorCount = Object.keys(this.state.validationErrors).length;
            messages.push(`${errorCount} item${errorCount !== 1 ? 's' : ''} ${errorCount === 1 ? 'has' : 'have'} missing required fields`);
        }

        if (hasMappingErrors) {
            messages.push(`${this.state.mappingErrors.join(', ')}`);
        }

        return {
            hasErrors: true,
            message: messages.join('. ') + '. Please review items below.'
        };
    };

    handleCancel = () => {
        if (this.state.itemslist.length > 0 || this.state.uploadedFiles.length > 0) {
            Swal.fire({
                title: "Unsaved Changes",
                text: "You have unsaved items. Are you sure you want to leave?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, leave",
                cancelButtonText: "No, stay",
                confirmButtonColor: "#dc2626",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.props.navigate(-1);
                }
            });
        } else {
            this.props.navigate(-1);
        }
    }

    handleAddNewCategory = () => {
        this.setState({
            addNewDialogOpen: true,
            newMainCategory: "",
            newSubCategory: "",
            newCategoryName: "",
            addNewMessage: "",
            saveLoading: false,
        });
    };

    handleAddNewSubCategory = () => {
        const isBulk = this.state.entrytype === 'bulk';
        const parentCatId = isBulk ? this.state.bulkFieldMappings.mcatid : this.state.mcatid;
        const parentCatName = isBulk ? this.state.bulkFieldMappings.mcategory : this.state.mcategory;

        if (!parentCatId) {
            Swal.fire({
                title: "Select Main Category First",
                text: "Please select a main category before adding a sub category",
                icon: "warning",
                confirmButtonText: "Ok",
            });
            return;
        }
        this.setState({
            addNewDialogOpenSub: true,
            newSubCategory: "",
            newCategoryName: "",
            addNewMessageSub: "",
            saveLoadingSub: false,
            dialogParentMainCategory: parentCatName,
        });
    };

    handleAddNewCategoryLevel3 = () => {
        const isBulk = this.state.entrytype === 'bulk';
        const parentSubCatId = isBulk ? this.state.bulkFieldMappings.catid2 : this.state.catid2;
        const parentMainCatName = isBulk ? this.state.bulkFieldMappings.mcategory : this.state.mcategory;
        const parentSubCatName = isBulk ? this.state.bulkFieldMappings.category2 : this.state.category2;

        if (!parentSubCatId) {
            Swal.fire({
                title: "Select Sub Category First",
                text: "Please select a sub category before adding a category level 3",
                icon: "warning",
                confirmButtonText: "Ok",
            });
            return;
        }
        this.setState({
            addNewDialogOpenLevel3: true,
            newCategoryName: "",
            addNewMessageLevel3: "",
            saveLoadingLevel3: false,
            dialogParentMainCategory: parentMainCatName,
            dialogParentSubCategory: parentSubCatName,
        });
    };

    handleAddNewBrand = () => {
        this.setState({
            addNewBrandDialogOpen: true,
            newBrandName: "",
            addNewMessageBrand: "",
            saveLoadingBrand: false,
        });
    };

    handleAddNewUom = () => {
        this.setState({
            addNewUomDialogOpen: true,
            newUomName: "",
            newUomDescription: "",
            addNewMessageUom: "",
            saveLoadingUom: false,
        });
    };

    submitNewBrand = () => {
        if (!this.state.newBrandName || this.state.newBrandName.trim() === "") {
            this.setState({ addNewMessageBrand: "Brand Name is required" });
            return;
        }

        this.setState({ saveLoadingBrand: true });

        // Client-side existence check
        const existingBrand = this.state.brandsList.find(b => (b.brand || '').toLowerCase() === this.state.newBrandName.trim().toLowerCase());
        if (existingBrand) {
            // Single atomic setState — matching Category pattern
            const brandName = existingBrand.brand;
            const brandId = existingBrand.id;
            const isBulk = this.state.entrytype === 'bulk';

            const updatedItems = isBulk ? this.state.itemslist.map(item => ({
                ...item,
                ...(!(item.manualFields && item.manualFields.brand) && { brand: brandName }),
                ...(!(item.manualFields && item.manualFields.brandid) && { brandid: brandId }),
            })) : this.state.itemslist;

            const updatedFiles = isBulk ? this.state.uploadedFiles.map(file => ({
                ...file,
                items: file.items.map(item => ({
                    ...item,
                    ...(!(item.manualFields && item.manualFields.brand) && { brand: brandName }),
                    ...(!(item.manualFields && item.manualFields.brandid) && { brandid: brandId }),
                }))
            })) : this.state.uploadedFiles;

            this.setState({
                brandid: brandId,
                brand: brandName,
                addNewBrandDialogOpen: false,
                saveLoadingBrand: false,
                newBrandName: "",
                ...(isBulk && {
                    itemslist: updatedItems,
                    uploadedFiles: updatedFiles,
                    bulkFieldMappings: {
                        ...this.state.bulkFieldMappings,
                        brand: brandName,
                        brandid: brandId
                    }
                })
            }, () => {
                if (isBulk) this.validateBulkItems();
                Swal.fire({
                    title: "Brand Exists",
                    text: "This brand already exists. Selected the existing one.",
                    icon: "info",
                    timer: 1500,
                    showConfirmButton: false
                });
            });
            return;
        }

        BrandsServices.addBrand({
            name: this.state.newBrandName,
            tenantid: currentTenant
        })
            .then(() => {
                // Re-fetch the full list (just like Category flow does)
                return BrandsServices.getBrands(currentTenant);
            })
            .then((response) => {
                const freshList = response.data || [];
                const uniqueBrands = [];
                const seen = new Set();
                freshList.forEach(b => {
                    if (!seen.has(b.id)) {
                        seen.add(b.id);
                        uniqueBrands.push(b);
                    }
                });

                // Find the newly created brand in the refreshed list — matching Category pattern
                const createdBrand = uniqueBrands.find(b =>
                    (b.brand || '').toLowerCase() === this.state.newBrandName.trim().toLowerCase()
                );

                const brandName = createdBrand ? createdBrand.brand : this.state.newBrandName;
                const brandId = createdBrand ? createdBrand.id : '';
                const isBulk = this.state.entrytype === 'bulk';

                // Single atomic setState — matching Category pattern
                const updatedItems = isBulk ? this.state.itemslist.map(item => ({
                    ...item,
                    ...(!(item.manualFields && item.manualFields.brand) && { brand: brandName }),
                    ...(!(item.manualFields && item.manualFields.brandid) && { brandid: brandId }),
                })) : this.state.itemslist;

                const updatedFiles = isBulk ? this.state.uploadedFiles.map(file => ({
                    ...file,
                    items: file.items.map(item => ({
                        ...item,
                        ...(!(item.manualFields && item.manualFields.brand) && { brand: brandName }),
                        ...(!(item.manualFields && item.manualFields.brandid) && { brandid: brandId }),
                    }))
                })) : this.state.uploadedFiles;

                this.setState({
                    brandsList: uniqueBrands,
                    brandid: brandId,
                    brand: brandName,
                    addNewBrandDialogOpen: false,
                    saveLoadingBrand: false,
                    newBrandName: "",
                    ...(isBulk && {
                        itemslist: updatedItems,
                        uploadedFiles: updatedFiles,
                        bulkFieldMappings: {
                            ...this.state.bulkFieldMappings,
                            brand: brandName,
                            brandid: brandId
                        }
                    })
                }, () => {
                    if (isBulk) this.validateBulkItems();
                    Swal.fire({
                        title: "Brand Added",
                        text: "New brand created successfully",
                        icon: "success",
                        timer: 1500,
                        showConfirmButton: false
                    });
                });
            })
            .catch((e) => {
                const msg = (e.response && e.response.data && e.response.data.message) || "Error adding brand";
                this.setState({ addNewMessageBrand: msg, saveLoadingBrand: false });
            });
    };

    submitNewUom = () => {
        if (!this.state.newUomName || this.state.newUomName.trim() === "") {
            this.setState({ addNewMessageUom: "UOM Name is required" });
            return;
        }

        this.setState({ saveLoadingUom: true });

        // Client-side existence check
        const existingUom = this.state.UOMList.find(u => (u.name || '').toLowerCase() === this.state.newUomName.trim().toLowerCase());
        if (existingUom) {
            // Single atomic setState — matching Category pattern
            const uomName = existingUom.name;
            const uomId = existingUom.id;
            const isBulk = this.state.entrytype === 'bulk';

            const updatedItems = isBulk ? this.state.itemslist.map(item => ({
                ...item,
                ...(!(item.manualFields && item.manualFields.uom) && { uom: uomName }),
                ...(!(item.manualFields && item.manualFields.uomid) && { uomid: uomId }),
            })) : this.state.itemslist;

            const updatedFiles = isBulk ? this.state.uploadedFiles.map(file => ({
                ...file,
                items: file.items.map(item => ({
                    ...item,
                    ...(!(item.manualFields && item.manualFields.uom) && { uom: uomName }),
                    ...(!(item.manualFields && item.manualFields.uomid) && { uomid: uomId }),
                }))
            })) : this.state.uploadedFiles;

            this.setState({
                uomid: uomId,
                uom: uomName,
                addNewUomDialogOpen: false,
                saveLoadingUom: false,
                newUomName: "",
                newUomDescription: "",
                errors: { ...this.state.errors, uom: null },
                ...(isBulk && {
                    itemslist: updatedItems,
                    uploadedFiles: updatedFiles,
                    bulkFieldMappings: {
                        ...this.state.bulkFieldMappings,
                        uom: uomName,
                        uomid: uomId
                    }
                })
            }, () => {
                if (isBulk) this.validateBulkItems();
                Swal.fire({
                    title: "UOM Exists",
                    text: "This UOM already exists. Selected the existing one.",
                    icon: "info",
                    timer: 1500,
                    showConfirmButton: false
                });
            });
            return;
        }

        UomServices.adduom({
            name: this.state.newUomName,
            description: this.state.newUomDescription,
            tenantid: currentTenant
        })
            .then(() => {
                // Re-fetch the full list (just like Category flow does)
                return UomServices.getUOM(currentTenant);
            })
            .then((response) => {
                const freshList = response.data || [];
                const uniqueUom = [];
                const seen = new Set();
                freshList.forEach(u => {
                    if (!seen.has(u.id)) {
                        seen.add(u.id);
                        uniqueUom.push(u);
                    }
                });

                // Find the newly created UOM in the refreshed list — matching Category pattern
                const createdUom = uniqueUom.find(u =>
                    (u.name || '').toLowerCase() === this.state.newUomName.trim().toLowerCase()
                );

                const uomName = createdUom ? createdUom.name : this.state.newUomName;
                const uomId = createdUom ? createdUom.id : '';
                const isBulk = this.state.entrytype === 'bulk';

                // Single atomic setState — matching Category pattern
                const updatedItems = isBulk ? this.state.itemslist.map(item => ({
                    ...item,
                    ...(!(item.manualFields && item.manualFields.uom) && { uom: uomName }),
                    ...(!(item.manualFields && item.manualFields.uomid) && { uomid: uomId }),
                })) : this.state.itemslist;

                const updatedFiles = isBulk ? this.state.uploadedFiles.map(file => ({
                    ...file,
                    items: file.items.map(item => ({
                        ...item,
                        ...(!(item.manualFields && item.manualFields.uom) && { uom: uomName }),
                        ...(!(item.manualFields && item.manualFields.uomid) && { uomid: uomId }),
                    }))
                })) : this.state.uploadedFiles;

                this.setState({
                    UOMList: uniqueUom,
                    uomid: uomId,
                    uom: uomName,
                    addNewUomDialogOpen: false,
                    saveLoadingUom: false,
                    newUomName: "",
                    newUomDescription: "",
                    errors: { ...this.state.errors, uom: null },
                    ...(isBulk && {
                        itemslist: updatedItems,
                        uploadedFiles: updatedFiles,
                        bulkFieldMappings: {
                            ...this.state.bulkFieldMappings,
                            uom: uomName,
                            uomid: uomId
                        }
                    })
                }, () => {
                    if (isBulk) this.validateBulkItems();
                    Swal.fire({
                        title: "UOM Added",
                        text: "New UOM created successfully",
                        icon: "success",
                        timer: 1500,
                        showConfirmButton: false
                    });
                });
            })
            .catch((e) => {
                const msg = (e.response && e.response.data && e.response.data.message) || "Error adding UOM";
                this.setState({ addNewMessageUom: msg, saveLoadingUom: false });
            });
    };

    submitNewCategory = () => {
        const { newMainCategory, newSubCategory, newCategoryName } = this.state;

        if (!newMainCategory || newMainCategory.trim() === "") {
            this.setState({ addNewMessage: "Main Category is required" });
            return;
        }

        this.setState({ saveLoading: true });

        let mainId, subId, level3Id;

        CategoryServices.addMainCategory({
            category: newMainCategory,
            tenantid: currentTenant,
            categorytype: 0,
        })
            .then((res) => {
                mainId = res.data;

                if (newSubCategory && newSubCategory.trim() !== "") {
                    return CategoryServices.addCategorylvl2({
                        name: newSubCategory,
                        category: mainId,
                        tenantid: currentTenant,
                    });
                }
                return { data: null };
            })
            .then((res) => {
                if (res && res.data) {
                    subId = res.data;
                    if (newCategoryName && newCategoryName.trim() !== "") {
                        return CategoryServices.addCategory({
                            category: newCategoryName,
                            catid: subId,
                            categorytype: 0,
                            tenantid: currentTenant,
                        });
                    }
                }
                return { data: null };
            })
            .then((res) => {
                if (res && res.data) {
                    level3Id = res.data;
                }
                return CategoryServices.getMainCategory(currentTenant);
            })
            .then((response) => {
                const updatedCategories = response.data.filter(e => e.categorytype === "Product");
                const newCategory = updatedCategories.find(cat => cat.category === newMainCategory);

                if (newCategory) {
                    // Auto-populate itemslist and uploadedFiles with the new main category
                    const updatedItems = this.state.itemslist.map(item => ({
                        ...item,
                        mcategory: newCategory.category,
                        mcatid: newCategory.id,
                        categorytype: newCategory.categorytype,
                        category2: subId ? newSubCategory : '',
                        catid2: subId || '',
                        category: level3Id ? newCategoryName : '',
                        catid: level3Id || ''
                    }));

                    const updatedFiles = this.state.uploadedFiles.map(file => ({
                        ...file,
                        items: file.items.map(item => ({
                            ...item,
                            mcategory: newCategory.category,
                            mcatid: newCategory.id,
                            categorytype: newCategory.categorytype,
                            category2: subId ? newSubCategory : '',
                            catid2: subId || '',
                            category: level3Id ? newCategoryName : '',
                            catid: level3Id || ''
                        }))
                    }));

                    this.setState({
                        mCategoryList: updatedCategories,
                        mcatid: newCategory.id,
                        mcategory: newCategory.category,
                        categorytype: newCategory.categorytype,

                        CategoryList2: newCategory.categorylvltwo || [],
                        ...(subId && {
                            catid2: subId,
                            category2: newSubCategory
                        }),

                        ...(level3Id && {
                            CategoryList: newCategory.categorylvltwo.find(sub => sub.id === subId)?.category || [],
                            catid: level3Id,
                            category: newCategoryName
                        }),

                        bulkFieldMappings: {
                            ...this.state.bulkFieldMappings,
                            mcategory: newCategory.category,
                            mcatid: newCategory.id,
                            categorytype: newCategory.categorytype,
                            category2: subId ? newSubCategory : '',
                            catid2: subId || '',
                            category: level3Id ? newCategoryName : '',
                            catid: level3Id || ''
                        },

                        itemslist: updatedItems,
                        uploadedFiles: updatedFiles,

                        addNewDialogOpen: false,
                        saveLoading: false,
                        newMainCategory: "",
                        newSubCategory: "",
                        newCategoryName: "",
                        errors: { ...this.state.errors, mcategory: null, category2: null, category: null }
                    }, () => {
                        this.validateBulkItems();
                    });
                }
            })
            .catch((e) => {
                const msg = (e.response && e.response.data && e.response.data.message) || "Server error";
                this.setState({ addNewMessage: msg, saveLoading: false });
            });
    };

    submitNewSubCategory = () => {
        const { newSubCategory, newCategoryName } = this.state;

        if (!newSubCategory || newSubCategory.trim() === "") {
            this.setState({ addNewMessageSub: "Sub Category is required" });
            return;
        }

        this.setState({ saveLoadingSub: true });

        let subId, level3Id;

        const isBulk = this.state.entrytype === 'bulk';
        const parentCatId = isBulk ? this.state.bulkFieldMappings.mcatid : this.state.mcatid;

        CategoryServices.addCategorylvl2({
            name: newSubCategory,
            category: parentCatId,
            tenantid: currentTenant,
        })
            .then((res) => {
                subId = res.data;

                if (newCategoryName && newCategoryName.trim() !== "") {
                    return CategoryServices.addCategory({
                        category: newCategoryName,
                        catid: subId,
                        categorytype: 0,
                        tenantid: currentTenant,
                    });
                }
                return { data: null };
            })
            .then((res) => {
                if (res && res.data) {
                    level3Id = res.data;
                }
                return CategoryServices.getMainCategoryById(parentCatId);
            })
            .then((response) => {
                const updatedMainCategory = response.data;

                const updatedMCategoryList = this.state.mCategoryList.map(cat =>
                    cat.id === parentCatId ? updatedMainCategory : cat
                );

                // Auto-populate itemslist and uploadedFiles with the new sub-category
                const updatedItems = this.state.itemslist.map(item => ({
                    ...item,
                    category2: newSubCategory,
                    catid2: subId,
                    category: level3Id ? newCategoryName : '',
                    catid: level3Id || ''
                }));

                const updatedFiles = this.state.uploadedFiles.map(file => ({
                    ...file,
                    items: file.items.map(item => ({
                        ...item,
                        category2: newSubCategory,
                        catid2: subId,
                        category: level3Id ? newCategoryName : '',
                        catid: level3Id || ''
                    }))
                }));

                this.setState({
                    mCategoryList: updatedMCategoryList,
                    CategoryList2: updatedMainCategory.categorylvltwo || [],
                    catid2: subId,
                    category2: newSubCategory,
                    CategoryList: level3Id ? (updatedMainCategory.categorylvltwo.find(sub => sub.id === subId)?.category || []) : [],
                    catid: level3Id || '',
                    category: level3Id ? newCategoryName : '',

                    bulkFieldMappings: {
                        ...this.state.bulkFieldMappings,
                        category2: newSubCategory,
                        catid2: subId,
                        category: level3Id ? newCategoryName : '',
                        catid: level3Id || ''
                    },

                    itemslist: updatedItems,
                    uploadedFiles: updatedFiles,

                    addNewDialogOpenSub: false,
                    saveLoadingSub: false,
                    newSubCategory: "",
                    newCategoryName: "",
                    errors: { ...this.state.errors, category2: null, category: null }
                }, () => {
                    this.validateBulkItems();
                });
            })
            .catch((e) => {
                const msg = (e.response && e.response.data && e.response.data.message) || "Server error";
                this.setState({ addNewMessageSub: msg, saveLoadingSub: false });
            });
    };

    submitNewCategoryLevel3 = () => {
        const { newCategoryName } = this.state;

        if (!newCategoryName || newCategoryName.trim() === "") {
            this.setState({ addNewMessageLevel3: "Category Level 3 is required" });
            return;
        }

        this.setState({ saveLoadingLevel3: true });

        let level3Id;

        const isBulk = this.state.entrytype === 'bulk';
        const parentSubCatId = isBulk ? this.state.bulkFieldMappings.catid2 : this.state.catid2;

        CategoryServices.addCategory({
            category: newCategoryName,
            catid: parentSubCatId,
            categorytype: 0,
            tenantid: currentTenant,
        })
            .then((res) => {
                level3Id = res.data;
                return CategoryServices.getCategorylvl2ById(parentSubCatId);
            })
            .then((response) => {
                const updatedSubCategory = response.data;

                const updatedCategoryList2 = this.state.CategoryList2.map(subCat =>
                    subCat.id === parentSubCatId ? updatedSubCategory : subCat
                );

                const updatedMCategoryList = this.state.mCategoryList.map(mainCat => ({
                    ...mainCat,
                    categorylvltwo: mainCat.categorylvltwo.map(subCat =>
                        subCat.id === parentSubCatId ? updatedSubCategory : subCat
                    )
                }));

                // Auto-populate itemslist and uploadedFiles with the new Level 3 category
                const updatedItems = this.state.itemslist.map(item => ({
                    ...item,
                    category: newCategoryName,
                    catid: level3Id
                }));

                const updatedFiles = this.state.uploadedFiles.map(file => ({
                    ...file,
                    items: file.items.map(item => ({
                        ...item,
                        category: newCategoryName,
                        catid: level3Id
                    }))
                }));

                this.setState({
                    CategoryList2: updatedCategoryList2,
                    mCategoryList: updatedMCategoryList,
                    CategoryList: updatedSubCategory.category || [],
                    catid: level3Id,
                    category: newCategoryName,

                    bulkFieldMappings: {
                        ...this.state.bulkFieldMappings,
                        category: newCategoryName,
                        catid: level3Id
                    },

                    itemslist: updatedItems,
                    uploadedFiles: updatedFiles,

                    addNewDialogOpenLevel3: false,
                    saveLoadingLevel3: false,
                    newCategoryName: "",
                    errors: { ...this.state.errors, category: null }
                }, () => {
                    this.validateBulkItems();
                });
            })
            .catch((e) => {
                const msg = (e.response && e.response.data && e.response.data.message) || "Server error";
                this.setState({ addNewMessageLevel3: msg, saveLoadingLevel3: false });
            });
    };

    handleparameters = (e) => {
        this.setState({ parameters: e.target.checked })
    }

    handleSelect = (e) => {
        this.setState({ status: e.target.value });
    };

    handleCategory = (value, values) => {
        if (values !== '' && typeof values === 'object' && values !== null) {
            let data = this.state.mCategoryList.find(e => e.id === values.id).categorylvltwo;
            this.setState({
                mcatid: values.id,
                mcategory: values.category,
                categorytype: values.categorytype,
                CategoryList2: data,
                catid2: '',
                category2: '',
                catid: '',
                category: '',
                CategoryList: [],
                errors: { ...this.state.errors, mcategory: null, category2: null, category: null }
            });
        } else {
            this.setState({
                catid: '',
                category: '',
                catid2: '',
                category2: '',
                CategoryList2: [],
                mcatid: '',
                mcategory: '',
                CategoryList: []
            });
        }
    };

    handleCategory2 = (value, values) => {
        if (values !== '' && typeof values === 'object' && values !== null) {
            let data = this.state.CategoryList2.find(e => e.id === values.id).category;
            this.setState({
                catid2: values.id,
                category2: values.name,
                CategoryList: data,
                catid: '',
                category: '',
                errors: { ...this.state.errors, category2: null, category: null }
            });
        } else {
            this.setState({
                catid2: '',
                category2: '',
                catid: '',
                category: '',
                CategoryList: []
            });
        }
    };

    handleCategory3 = (value, values) => {
        if (values !== '' && typeof values === 'object' && values !== null) {
            this.setState({
                catid: values.id,
                category: values.category,
                errors: { ...this.state.errors, category: null }
            });
        } else {
            this.setState({ catid: '', category: '' });
        }
    };

    handleUOM = (value, values) => {
        if (values !== '' && typeof values === 'object' && values !== null) {
            this.setState({
                uomid: values.id,
                uom: values.name,
                errors: { ...this.state.errors, uom: null }
            });
        } else {
            this.setState({ uomid: '', uom: '' });
        }
    }

    handlebrand = (value, values) => {
        if (values !== '' && typeof values === 'object' && values !== null) {
            this.setState({ brandid: values.id, brand: values.brand });
        } else {
            this.setState({ brandid: '', brand: '' });
        }
    }

    handleChange = (e) => {
        this.setState({ istatus: e.target.value });
    };

    handletax = (e) => {
        this.setState({ tax: parseInt(e) });
    }

    downloadExcel = () => {
        const templateData = [
            {
                'Item Name*': '',
                'Item Code*': '',
                'HSN Code': '',
                'Tax Rate (%)': '',
                'Model': '',
                'Description*': ''
            },
            {
                'Item Name*': 'Sample Item 1',
                'Item Code*': 'ITM001',
                'HSN Code': '123456',
                'Tax Rate (%)': '18',
                'Model': 'Model A',
                'Description*': 'Sample description for item 1'
            },
            {
                'Item Name*': 'Sample Item 2',
                'Item Code*': 'ITM002',
                'HSN Code': '654321',
                'Tax Rate (%)': '12',
                'Model': 'Model B',
                'Description*': 'Sample description for item 2'
            }
        ];

        const ws = XLSX.utils.json_to_sheet(templateData, { skipHeader: false });

        const wscols = [
            { wch: 20 },
            { wch: 15 },
            { wch: 12 },
            { wch: 15 },
            { wch: 15 },
            { wch: 40 }
        ];
        ws['!cols'] = wscols;

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Items");

        XLSX.writeFile(wb, 'Items_Template.xlsx');
    }

    validateFile = (file) => {
        // Check file size (max 5MB)
        const maxSize = 5 * 1024 * 1024;
        if (file.size > maxSize) {
            Swal.fire({
                title: "File Too Large",
                text: "File size exceeds 5MB limit. Please upload a smaller file.",
                icon: "error",
                confirmButtonText: "Ok",
            });
            return false;
        }

        const validExtensions = ['.xlsx', '.xls'];
        const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

        if (!validExtensions.includes(fileExtension)) {
            Swal.fire({
                title: "Invalid File Format",
                text: "Please upload only Excel files (.xlsx or .xls)",
                icon: "error",
                confirmButtonText: "Ok",
            });
            return false;
        }

        return true;
    }

    readExcel = async (file) => {
        if (!file) return;

        // 1. Duplicate File Validation
        const isDuplicateFile = this.state.uploadedFiles.some(f => f.name === file.name && f.size === file.size);
        if (isDuplicateFile) {
            const result = await Swal.fire({
                title: "Duplicate File Detected",
                text: `The file "${file.name}" has already been uploaded. Do you want to upload it again?`,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Yes, upload again",
                cancelButtonText: "No, cancel",
                confirmButtonColor: "#1976d2",
            });

            if (!result.isConfirmed) {
                // User rejected the duplicate file
                return;
            }
        }

        // Validate file type and size
        if (!this.validateFile(file)) {
            return;
        }

        this.setState({ fileUploadLoading: true, fileUploadProgress: 0 });

        const promise = new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);

            fileReader.onloadstart = () => {
                this.setState({ fileUploadProgress: 10 });
            };

            fileReader.onprogress = (e) => {
                if (e.lengthComputable) {
                    const progress = Math.round((e.loaded / e.total) * 90);
                    this.setState({ fileUploadProgress: progress });
                }
            };

            fileReader.onload = (e) => {
                this.setState({ fileUploadProgress: 95 });
                const bufferArray = e.target.result;
                const wb = XLSX.read(bufferArray, { type: 'buffer' });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];

                // 2. File Format (Standard) Validation
                // Get headers from the first row
                const range = XLSX.utils.decode_range(ws['!ref']);
                const headers = [];
                for (let C = range.s.c; C <= range.e.c; ++C) {
                    const address = XLSX.utils.encode_col(C) + "1";
                    if (ws[address]) headers.push(ws[address].v.toString().trim());
                }

                const requiredHeaders = ['Item Name*', 'Item Code*', 'Description*'];
                const missingHeaders = requiredHeaders.filter(h => !headers.includes(h));

                if (missingHeaders.length > 0) {
                    this.setState({ fileUploadLoading: false, fileUploadProgress: 0 });
                    Swal.fire({
                        title: "Invalid File Format",
                        html: `
                            <div style="text-align: left; font-size: 0.9rem;">
                                <p>The uploaded file does not match the required standard. Missing columns:</p>
                                <ul style="color: #dc2626; font-weight: 600;">
                                    ${missingHeaders.map(h => `<li>${h}</li>`).join('')}
                                </ul>
                                <p>Please use the sample template and ensure all mandatory fields (marked with *) are present.</p>
                            </div>
                        `,
                        icon: "error",
                        confirmButtonText: "Ok",
                    });
                    reject(new Error("Invalid format"));
                    return;
                }

                const data = XLSX.utils.sheet_to_json(ws);
                resolve(data);
            };

            fileReader.onerror = error => {
                reject(error);
            };
        });

        promise.then((d) => {
            // Process data
            let items = d.filter(e => {
                const name = e['Item Name*'] || e['Item Name'] || e.name || e.Name;
                const itemcode = e['Item Code*'] || e['Item Code'] || e.itemcode || e.ItemCode;
                const description = e['Description*'] || e.Description || e.description;

                return name && name.toString().trim() !== "" &&
                    itemcode && itemcode.toString().trim() !== "" &&
                    description && description.toString().trim() !== "";
            });

            const processedItems = items.map(e => {
                return {
                    name: e['Item Name*'] || e['Item Name'] || e.name || e.Name || '',
                    itemcode: e['Item Code*'] || e['Item Code'] || e.itemcode || e.ItemCode || '',
                    hsn: e['HSN Code'] || e.hsn || e.HSN || '',
                    tax: e['Tax Rate (%)'] || e.tax || e.Tax || 0,
                    model: e.Model || e.model || '',
                    description: e['Description*'] || e.Description || e.description || ''
                };
            });

            const fileId = Date.now();
            const fileItems = processedItems.map((e, index) => ({
                ...e,
                id: `${fileId}-${index}`,
                fileId: fileId,
                mcatid: this.state.bulkFieldMappings.mcatid || '',
                mcategory: this.state.bulkFieldMappings.mcategory || '',
                catid2: this.state.bulkFieldMappings.catid2 || '',
                category2: this.state.bulkFieldMappings.category2 || '',
                catid: this.state.bulkFieldMappings.catid || '',
                category: this.state.bulkFieldMappings.category || '',
                uom: this.state.bulkFieldMappings.uom || '',
                uomid: this.state.bulkFieldMappings.uomid || '',
                brand: this.state.bulkFieldMappings.brand || '',
                brandid: this.state.bulkFieldMappings.brandid || '',
                parameters: this.state.bulkFieldMappings.parameters || false,
                isEditing: false,
                manualFields: {}
            }));

            const allItemCodes = [...this.state.itemslist, ...fileItems].map(item => item.itemcode);
            const duplicates = this.findDuplicates(allItemCodes);

            this.setState(prevState => ({
                uploadedFiles: [
                    ...prevState.uploadedFiles,
                    {
                        id: fileId,
                        name: file.name,
                        items: fileItems,
                        size: file.size,
                        uploadDate: new Date().toISOString()
                    }
                ],
                itemslist: [...prevState.itemslist, ...fileItems],
                duplicateItemCodes: duplicates,
                fileUploadLoading: false,
                fileUploadProgress: 0,
                selectedItems: [],
                showValidationSummary: false
            }), () => {
                this.validateBulkItems();
                console.log('Upload completed. Duplicates found:', duplicates.length);
            });
        }).catch(error => {
            if (error.message === "Invalid format") {
                // Already handled in validate header section
                return;
            }
            console.error('Error reading Excel file:', error);
            this.setState({ fileUploadLoading: false, fileUploadProgress: 0 });
            Swal.fire({
                title: "Error Reading File",
                text: "Failed to read Excel file. Please check the format and try again.",
                icon: "error",
                confirmButtonText: "Ok",
            });
        });
    }

    findDuplicates = (arr) => {
        const duplicates = [];
        const seen = new Set();
        const counts = {};

        arr.forEach(item => {
            counts[item] = (counts[item] || 0) + 1;
        });

        Object.keys(counts).forEach(item => {
            if (counts[item] > 1) {
                duplicates.push(item);
            }
        });

        return duplicates;
    }

    validateBulkItems = () => {
        const validationErrors = {};
        const mappingErrors = [];
        const items = this.state.itemslist;

        items.forEach((item, index) => {
            const errors = [];

            if (!item.name || item.name.trim() === '') {
                errors.push('Item Name is required');
            }

            if (!item.itemcode || item.itemcode.trim() === '') {
                errors.push('Item Code is required');
            }

            if (!item.description || item.description.trim() === '') {
                errors.push('Description is required');
            }

            // Enhanced check for Categories/UOM
            if (!item.mcategory || item.mcategory.trim() === '') {
                errors.push('Main Category is required');
            }

            if (!item.uom || item.uom.trim() === '') {
                errors.push('UOM is required');
            }

            if (errors.length > 0) {
                validationErrors[item.id] = errors;
            }
        });

        // Global mapping errors check
        const itemsMissingMCat = items.filter(item => !item.mcategory || item.mcategory.trim() === '');
        if (itemsMissingMCat.length > 0 && (!this.state.bulkFieldMappings.mcategory || this.state.bulkFieldMappings.mcategory.trim() === '')) {
            mappingErrors.push('Main Category is missing');
        }

        const itemsMissingUOM = items.filter(item => !item.uom || item.uom.trim() === '');
        if (itemsMissingUOM.length > 0 && (!this.state.bulkFieldMappings.uom || this.state.bulkFieldMappings.uom.trim() === '')) {
            mappingErrors.push('UOM is missing');
        }

        const hasErrors = Object.keys(validationErrors).length > 0 || mappingErrors.length > 0 || this.state.duplicateItemCodes.length > 0;

        if (!hasErrors) {
            this.setState({
                validationErrors,
                mappingErrors,
                showOnlyErrors: false,
                showValidData: false
            });
        } else {
            this.setState({ validationErrors, mappingErrors });
        }

        return {
            isValid: Object.keys(validationErrors).length === 0 && mappingErrors.length === 0,
            validationErrors,
            mappingErrors
        };
    }

    Removeitem = (id) => {
        this.setState(prevState => {
            const newItemslist = prevState.itemslist.filter(e => e.id !== id);

            const newUploadedFiles = prevState.uploadedFiles.map(file => ({
                ...file,
                items: file.items.filter(item => item.id !== id)
            })).filter(file => file.items.length > 0);

            const allItemCodes = newItemslist.map(item => item.itemcode);
            const duplicates = this.findDuplicates(allItemCodes);

            const newSelectedItems = prevState.selectedItems.filter(itemId => itemId !== id);

            return {
                itemslist: newItemslist,
                uploadedFiles: newUploadedFiles,
                duplicateItemCodes: duplicates,
                selectedItems: newSelectedItems,
                showValidationSummary: false
            };
        });
    }

    removeFile = (fileId) => {
        Swal.fire({
            title: "Remove File?",
            text: "This will remove all items from this file.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Remove",
            cancelButtonText: "Cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState(prevState => {
                    const newItemslist = prevState.itemslist.filter(item => item.fileId !== fileId);
                    const newUploadedFiles = prevState.uploadedFiles.filter(file => file.id !== fileId);

                    const allItemCodes = newItemslist.map(item => item.itemcode);
                    const duplicates = this.findDuplicates(allItemCodes);

                    const newSelectedItems = prevState.selectedItems.filter(itemId => {
                        const item = prevState.itemslist.find(i => i.id === itemId);
                        return !item || item.fileId !== fileId;
                    });

                    return {
                        itemslist: newItemslist,
                        uploadedFiles: newUploadedFiles,
                        duplicateItemCodes: duplicates,
                        selectedItems: newSelectedItems,
                        showValidationSummary: false
                    };
                });
            }
        });
    }

    clearAll = () => {
        Swal.fire({
            title: "Clear All Data?",
            text: "This will remove all uploaded files and items.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Clear All",
            cancelButtonText: "Cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({
                    itemslist: [],
                    uploadedFiles: [],
                    bulkEditItemId: null,
                    editingItem: null,
                    duplicateItemCodes: [],
                    validationErrors: {},
                    mappingErrors: [],
                    selectedItems: [],
                    selectAll: false,
                    showValidationSummary: false
                });
            }
        });
    }

    toggleItemSelection = (itemId) => {
        this.setState(prevState => {
            const isSelected = prevState.selectedItems.includes(itemId);
            let newSelectedItems;

            if (isSelected) {
                newSelectedItems = prevState.selectedItems.filter(id => id !== itemId);
            } else {
                newSelectedItems = [...prevState.selectedItems, itemId];
            }

            const selectAll = newSelectedItems.length === prevState.itemslist.length;

            return {
                selectedItems: newSelectedItems,
                selectAll
            };
        });
    };

    toggleSelectAll = () => {
        this.setState(prevState => {
            const newSelectAll = !prevState.selectAll;
            const newSelectedItems = newSelectAll ?
                prevState.itemslist.map(item => item.id) :
                [];

            return {
                selectAll: newSelectAll,
                selectedItems: newSelectedItems
            };
        });
    };

    startEditItem = (item) => {
        let mainCategory = this.state.mCategoryList.find(cat => cat.id === item.mcatid);
        if (!mainCategory && item.mcategory) {
            mainCategory = this.state.mCategoryList.find(cat => cat.category.toLowerCase() === item.mcategory.toLowerCase());
        }

        const subCategories = mainCategory?.categorylvltwo || [];

        let subCategory = subCategories.find(sub => sub.id === item.catid2);
        if (!subCategory && item.category2) {
            subCategory = subCategories.find(sub => sub.name.toLowerCase() === item.category2.toLowerCase());
        }

        const level3Categories = subCategory?.category || [];

        let level3Category = level3Categories.find(lvl3 => lvl3.id === item.catid);
        if (!level3Category && item.category) {
            level3Category = level3Categories.find(lvl3 => lvl3.category.toLowerCase() === item.category.toLowerCase());
        }

        let uomObj = this.state.UOMList.find(uom => uom.id === item.uomid);
        if (!uomObj && item.uom) {
            uomObj = this.state.UOMList.find(uom => uom.name.toLowerCase() === item.uom.toLowerCase());
        }

        let brandObj = this.state.brandsList.find(brand => brand.id === item.brandid);
        if (!brandObj && item.brand) {
            brandObj = this.state.brandsList.find(brand => brand.brand.toLowerCase() === item.brand.toLowerCase());
        }

        this.setState({
            editingItem: {
                ...item,
                _mcategoryObj: mainCategory || null,
                _subcategoryObj: subCategory || null,
                _level3Obj: level3Category || null,
                _uomObj: uomObj || null,
                _brandObj: brandObj || null,
                mcatid: mainCategory?.id || item.mcatid,
                catid2: subCategory?.id || item.catid2,
                catid: level3Category?.id || item.catid,
                uomid: uomObj?.id || item.uomid,
                brandid: brandObj?.id || item.brandid
            },
            bulkEditItemId: item.id,
            editSubCategoryList: subCategories,
            editLevel3CategoryList: level3Categories
        });
    }

    saveEditItem = () => {
        if (!this.state.editingItem) return;

        this.setState(prevState => {
            const updatedItem = {
                ...prevState.editingItem,
                _mcategoryObj: undefined,
                _subcategoryObj: undefined,
                _level3Obj: undefined,
                _uomObj: undefined,
                _brandObj: undefined
            };

            const newItemslist = prevState.itemslist.map(item =>
                item.id === prevState.bulkEditItemId ? updatedItem : item
            );

            const newUploadedFiles = prevState.uploadedFiles.map(file => ({
                ...file,
                items: file.items.map(item =>
                    item.id === prevState.bulkEditItemId ? updatedItem : item
                )
            }));

            const allItemCodes = newItemslist.map(item => item.itemcode);
            const duplicates = this.findDuplicates(allItemCodes);

            const newValidationErrors = { ...prevState.validationErrors };
            delete newValidationErrors[prevState.bulkEditItemId];

            return {
                itemslist: newItemslist,
                uploadedFiles: newUploadedFiles,
                editingItem: null,
                bulkEditItemId: null,
                duplicateItemCodes: duplicates,
                validationErrors: newValidationErrors,
                editSubCategoryList: [],
                editLevel3CategoryList: []
            };
        }, () => {
            this.validateBulkItems();
        });
    }

    cancelEditItem = () => {
        this.setState({
            editingItem: null,
            bulkEditItemId: null,
            editSubCategoryList: [],
            editLevel3CategoryList: []
        });
    }

    updateEditField = (field, value) => {
        this.setState(prevState => {
            let updatedItem = { ...prevState.editingItem };
            const manualFields = { ...(updatedItem.manualFields || {}) };

            // Mark field as manual
            if (field === 'mcategory') {
                manualFields.mcategory = true;
                manualFields.category2 = true;
                manualFields.category = true;
            } else if (field === 'category2') {
                manualFields.category2 = true;
                manualFields.category = true;
            } else if (field === 'category') {
                manualFields.category = true;
            } else {
                manualFields[field] = true;
            }

            updatedItem.manualFields = manualFields;

            if (field === 'mcategory') {
                if (typeof value === 'object' && value !== null) {
                    if (value.inputValue === 'add-new') {
                        this.handleAddNewCategory();
                        return { editingItem: prevState.editingItem };
                    }
                    const mainCategory = value;
                    const subCategories = mainCategory?.categorylvltwo || [];

                    updatedItem = {
                        ...updatedItem,
                        mcategory: mainCategory.category,
                        mcatid: mainCategory.id,
                        categorytype: mainCategory.categorytype,
                        _mcategoryObj: mainCategory,
                        catid2: '',
                        category2: '',
                        _subcategoryObj: null,
                        catid: '',
                        category: '',
                        _level3Obj: null,
                    };

                    this.setState({
                        editSubCategoryList: subCategories,
                        editLevel3CategoryList: []
                    });
                } else if (value === null) {
                    updatedItem = {
                        ...updatedItem,
                        mcategory: '',
                        mcatid: '',
                        categorytype: '',
                        _mcategoryObj: null,
                        catid2: '',
                        category2: '',
                        _subcategoryObj: null,
                        catid: '',
                        category: '',
                        _level3Obj: null,
                    };

                    this.setState({
                        editSubCategoryList: [],
                        editLevel3CategoryList: []
                    });
                }
            } else if (field === 'category2') {
                if (typeof value === 'object' && value !== null) {
                    if (value.inputValue === 'add-new') {
                        this.handleAddNewCategoryLevel2();
                        return { editingItem: prevState.editingItem };
                    }
                    const subCategory = value;
                    const level3Categories = subCategory?.category || [];

                    updatedItem = {
                        ...updatedItem,
                        catid2: subCategory.id,
                        category2: subCategory.name,
                        _subcategoryObj: subCategory,
                        catid: '',
                        category: '',
                        _level3Obj: null,
                    };

                    this.setState({
                        editLevel3CategoryList: level3Categories
                    });
                } else if (value === null) {
                    updatedItem = {
                        ...updatedItem,
                        catid2: '',
                        category2: '',
                        _subcategoryObj: null,
                        catid: '',
                        category: '',
                        _level3Obj: null,
                    };

                    this.setState({
                        editLevel3CategoryList: []
                    });
                }
            } else if (field === 'category') {
                if (typeof value === 'object' && value !== null) {
                    if (value.inputValue === 'add-new') {
                        this.handleAddNewCategoryLevel3();
                        return { editingItem: prevState.editingItem };
                    }
                    const level3Category = value;

                    updatedItem = {
                        ...updatedItem,
                        catid: level3Category.id,
                        category: level3Category.category,
                        _level3Obj: level3Category
                    };
                } else if (value === null) {
                    updatedItem = {
                        ...updatedItem,
                        catid: '',
                        category: '',
                        _level3Obj: null
                    };
                }
            } else if (field === 'uom') {
                if (typeof value === 'object' && value !== null) {
                    if (value.inputValue === 'add-new') {
                        this.handleAddNewUom();
                        return { editingItem: prevState.editingItem };
                    }
                    const uom = value;
                    updatedItem = {
                        ...updatedItem,
                        uom: uom.name,
                        uomid: uom.id,
                        _uomObj: uom
                    };
                } else if (value === null) {
                    updatedItem = {
                        ...updatedItem,
                        uom: '',
                        uomid: '',
                        _uomObj: null
                    };
                }
            } else if (field === 'brand') {
                if (typeof value === 'object' && value !== null) {
                    if (value.inputValue === 'add-new') {
                        this.handleAddNewBrand();
                        return { editingItem: prevState.editingItem };
                    }
                    const brand = value;
                    updatedItem = {
                        ...updatedItem,
                        brand: brand.brand,
                        brandid: brand.id,
                        _brandObj: brand
                    };
                } else if (value === null) {
                    updatedItem = {
                        ...updatedItem,
                        brand: '',
                        brandid: '',
                        _brandObj: null
                    };
                }
            } else if (field === 'parameters') {
                updatedItem[field] = value;
            } else {
                updatedItem[field] = value;
            }

            return { editingItem: updatedItem };
        });
    }

    applyMappingToAll = (updates) => {
        this.setState(prevState => {
            const newItemslist = prevState.itemslist.map(item => {
                let updatedItem = { ...item };
                Object.keys(updates).forEach(field => {
                    if (!(item.manualFields && item.manualFields[field])) {
                        updatedItem[field] = updates[field];
                    }
                });
                return updatedItem;
            });

            const newUploadedFiles = prevState.uploadedFiles.map(file => ({
                ...file,
                items: file.items.map(item => {
                    let updatedItem = { ...item };
                    Object.keys(updates).forEach(field => {
                        if (!(item.manualFields && item.manualFields[field])) {
                            updatedItem[field] = updates[field];
                        }
                    });
                    return updatedItem;
                })
            }));

            return {
                itemslist: newItemslist,
                uploadedFiles: newUploadedFiles,
                bulkFieldMappings: {
                    ...prevState.bulkFieldMappings,
                    ...updates
                }
            };
        }, () => {
            this.validateBulkItems();
        });
    }

    applyAllMappings = (silent = false) => {
        const { itemslist, uploadedFiles, bulkFieldMappings } = this.state;

        const newItemslist = itemslist.map(item => {
            let updatedItem = { ...item };

            // Apply mappings only to empty fields
            if ((!updatedItem.mcategory || updatedItem.mcategory === "") && bulkFieldMappings.mcategory) {
                updatedItem.mcategory = bulkFieldMappings.mcategory;
                updatedItem.mcatid = bulkFieldMappings.mcatid;
                updatedItem.categorytype = bulkFieldMappings.categorytype;
            }

            if ((!updatedItem.category2 || updatedItem.category2 === "") && bulkFieldMappings.category2) {
                updatedItem.category2 = bulkFieldMappings.category2;
                updatedItem.catid2 = bulkFieldMappings.catid2;
            }

            if ((!updatedItem.category || updatedItem.category === "") && bulkFieldMappings.category) {
                updatedItem.category = bulkFieldMappings.category;
                updatedItem.catid = bulkFieldMappings.catid;
            }

            if ((!updatedItem.uom || updatedItem.uom === "") && bulkFieldMappings.uom) {
                updatedItem.uom = bulkFieldMappings.uom;
                updatedItem.uomid = bulkFieldMappings.uomid;
            }

            if ((!updatedItem.brand || updatedItem.brand === "") && bulkFieldMappings.brand) {
                updatedItem.brand = bulkFieldMappings.brand;
                updatedItem.brandid = bulkFieldMappings.brandid;
            }

            return updatedItem;
        });

        const newUploadedFiles = uploadedFiles.map(file => ({
            ...file,
            items: file.items.map(item => {
                const updated = newItemslist.find(ni => ni.id === item.id);
                return updated || item;
            })
        }));

        this.setState({
            itemslist: newItemslist,
            uploadedFiles: newUploadedFiles
        }, () => {
            this.validateBulkItems();
            if (!silent) {
                Swal.fire({
                    title: "Smart Fix Applied",
                    text: "Global values have been added to missing fields where available.",
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false
                });
            }
        });
    }

    handleBulkMainCategory = (event, newValue) => {
        if (newValue) {
            if (newValue.inputValue === 'add-new') {
                this.handleAddNewCategory();
            } else {
                this.setState({
                    bulkFieldMappings: {
                        ...this.state.bulkFieldMappings,
                        mcategory: newValue.category,
                        mcatid: newValue.id,
                        categorytype: newValue.categorytype,
                        category2: '',
                        catid2: '',
                        category: '',
                        catid: ''
                    },
                    CategoryList2: newValue.categorylvltwo || [],
                    CategoryList: []
                }, () => {
                    const updatedItems = this.state.itemslist.map(item => {
                        if (item.manualFields && item.manualFields.mcategory) return item;
                        return {
                            ...item,
                            mcategory: newValue.category,
                            mcatid: newValue.id,
                            categorytype: newValue.categorytype,
                            category2: '',
                            catid2: '',
                            category: '',
                            catid: ''
                        };
                    });

                    const updatedFiles = this.state.uploadedFiles.map(file => ({
                        ...file,
                        items: file.items.map(item => {
                            if (item.manualFields && item.manualFields.mcategory) return item;
                            return {
                                ...item,
                                mcategory: newValue.category,
                                mcatid: newValue.id,
                                categorytype: newValue.categorytype,
                                category2: '',
                                catid2: '',
                                category: '',
                                catid: ''
                            };
                        })
                    }));

                    this.setState({
                        itemslist: updatedItems,
                        uploadedFiles: updatedFiles
                    }, () => {
                        this.validateBulkItems();
                    });
                });
            }
        } else {
            this.setState({
                bulkFieldMappings: {
                    ...this.state.bulkFieldMappings,
                    mcategory: '',
                    mcatid: '',
                    categorytype: '',
                    category2: '',
                    catid2: '',
                    category: '',
                    catid: ''
                },
                CategoryList2: [],
                CategoryList: []
            }, () => {
                const updatedItems = this.state.itemslist.map(item => {
                    if (item.manualFields && item.manualFields.mcategory) return item;
                    return {
                        ...item,
                        mcategory: '',
                        mcatid: '',
                        categorytype: '',
                        category2: '',
                        catid2: '',
                        category: '',
                        catid: ''
                    };
                });

                const updatedFiles = this.state.uploadedFiles.map(file => ({
                    ...file,
                    items: file.items.map(item => {
                        if (item.manualFields && item.manualFields.mcategory) return item;
                        return {
                            ...item,
                            mcategory: '',
                            mcatid: '',
                            categorytype: '',
                            category2: '',
                            catid2: '',
                            category: '',
                            catid: ''
                        };
                    })
                }));

                this.setState({
                    itemslist: updatedItems,
                    uploadedFiles: updatedFiles
                }, () => {
                    this.validateBulkItems();
                });
            });
        }
    }

    handleBulkSubCategory = (event, newValue) => {
        if (newValue) {
            if (newValue.inputValue === 'add-new') {
                this.handleAddNewSubCategory();
            } else {
                this.setState({
                    bulkFieldMappings: {
                        ...this.state.bulkFieldMappings,
                        category2: newValue.name,
                        catid2: newValue.id,
                        category: '',
                        catid: ''
                    }
                }, () => {
                    const updatedItems = this.state.itemslist.map(item => {
                        if (item.manualFields && item.manualFields.category2) return item;
                        return {
                            ...item,
                            category2: newValue.name,
                            catid2: newValue.id,
                            category: '',
                            catid: ''
                        };
                    });

                    const updatedFiles = this.state.uploadedFiles.map(file => ({
                        ...file,
                        items: file.items.map(item => {
                            if (item.manualFields && item.manualFields.category2) return item;
                            return {
                                ...item,
                                category2: newValue.name,
                                catid2: newValue.id,
                                category: '',
                                catid: ''
                            };
                        })
                    }));

                    this.setState({
                        itemslist: updatedItems,
                        uploadedFiles: updatedFiles,
                        CategoryList: newValue.category || []
                    }, () => {
                        this.validateBulkItems();
                    });
                });
            }
        } else {
            this.setState({
                bulkFieldMappings: {
                    ...this.state.bulkFieldMappings,
                    category2: '',
                    catid2: '',
                    category: '',
                    catid: ''
                },
                CategoryList: []
            }, () => {
                const updatedItems = this.state.itemslist.map(item => {
                    if (item.manualFields && item.manualFields.category2) return item;
                    return {
                        ...item,
                        category2: '',
                        catid2: '',
                        category: '',
                        catid: ''
                    };
                });

                const updatedFiles = this.state.uploadedFiles.map(file => ({
                    ...file,
                    items: file.items.map(item => {
                        if (item.manualFields && item.manualFields.category2) return item;
                        return {
                            ...item,
                            category2: '',
                            catid2: '',
                            category: '',
                            catid: ''
                        };
                    })
                }));

                this.setState({
                    itemslist: updatedItems,
                    uploadedFiles: updatedFiles
                }, () => {
                    this.validateBulkItems();
                });
            });
        }
    }

    handleBulkLevel3Category = (event, newValue) => {
        if (newValue) {
            if (newValue.inputValue === 'add-new') {
                this.handleAddNewCategoryLevel3();
            } else {
                this.setState({
                    bulkFieldMappings: {
                        ...this.state.bulkFieldMappings,
                        category: newValue.category,
                        catid: newValue.id
                    }
                }, () => {
                    const updatedItems = this.state.itemslist.map(item => {
                        if (item.manualFields && item.manualFields.category) return item;
                        return {
                            ...item,
                            category: newValue.category,
                            catid: newValue.id
                        };
                    });

                    const updatedFiles = this.state.uploadedFiles.map(file => ({
                        ...file,
                        items: file.items.map(item => {
                            if (item.manualFields && item.manualFields.category) return item;
                            return {
                                ...item,
                                category: newValue.category,
                                catid: newValue.id
                            };
                        })
                    }));

                    this.setState({
                        itemslist: updatedItems,
                        uploadedFiles: updatedFiles
                    }, () => {
                        this.validateBulkItems();
                    });
                });
            }
        } else {
            this.setState({
                bulkFieldMappings: {
                    ...this.state.bulkFieldMappings,
                    category: '',
                    catid: ''
                }
            }, () => {
                const updatedItems = this.state.itemslist.map(item => {
                    if (item.manualFields && item.manualFields.category) return item;
                    return {
                        ...item,
                        category: '',
                        catid: ''
                    };
                });

                const updatedFiles = this.state.uploadedFiles.map(file => ({
                    ...file,
                    items: file.items.map(item => {
                        if (item.manualFields && item.manualFields.category) return item;
                        return {
                            ...item,
                            category: '',
                            catid: ''
                        };
                    })
                }));

                this.setState({
                    itemslist: updatedItems,
                    uploadedFiles: updatedFiles
                }, () => {
                    this.validateBulkItems();
                });
            });
        }
    }

    onSubmit() {
        if (this.state.entrytype === "manual") {
            const itemData = this.prepareItemObject(this.state, 'manual');

            if (this.state.id < 1) {
                Swal.fire({
                    title: "Are you sure?",
                    icon: "question",
                    showCancelButton: true,
                    showConfirmButton: true,
                    confirmButtonColor: "#1976d2",
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.setState({ loader: true });
                        InventoryService.createItems(itemData)
                            .then((response) => this.setState({ loader: false }, () =>
                                Swal.fire({
                                    title: `Item Added Successfully`,
                                    text: ".",
                                    icon: "success",
                                    confirmButtonText: "Ok",
                                    confirmButtonColor: "#1976d2",
                                }).then(() => this.props.navigate(-1))
                            ))
                            .catch((e) => {
                                this.setState({ message: e.response.data.message, loader: false }, () => {
                                    if (e.response.data.error === "Unauthorized") {
                                        Swal.fire({
                                            title: `Your Session is Lost: Please login Back to resume`,
                                            text: ".",
                                            icon: "error",
                                            confirmButtonText: "Ok",
                                            confirmButtonColor: "#1976d2",
                                        }).then(() => this.props.navigate('/'));
                                    } else {
                                        Swal.fire({
                                            title: `${e.response.data.message}`,
                                            text: ".",
                                            icon: "error",
                                            confirmButtonText: "Ok",
                                            confirmButtonColor: "#1976d2",
                                        });
                                    }
                                });
                            });
                    }
                });
            } else {
                this.setState({ loader: true });
                InventoryService.updateItems(itemData).then((response) =>
                    this.setState({ loader: false }, () =>
                        Swal.fire({
                            title: `Item Updated Successfully`,
                            text: "",
                            icon: "success",
                            confirmButtonText: "Ok",
                            confirmButtonColor: "#1976d2",
                        }).then(() => this.props.navigate(-1))
                    )
                )
                    .catch((e) =>
                        this.setState({ message: e.response.data.message, loader: false }, () => {
                            if (e.response.data.error === "Unauthorized") {
                                Swal.fire({
                                    title: `Your Session is Lost: Please login Back to resume`,
                                    text: ".",
                                    icon: "error",
                                    confirmButtonText: "Ok",
                                    confirmButtonColor: "#1976d2",
                                }).then(() => this.props.navigate('/'));
                            } else {
                                Swal.fire({
                                    title: `${e.response.data.message}`,
                                    text: ".",
                                    icon: "error",
                                    confirmButtonText: "Ok",
                                    confirmButtonColor: "#1976d2",
                                });
                            }
                        })
                    );
            }
        } else {
            this.submitBulkItems();
        }
    }

    submitBulkItems = async (specificItems = null) => {
        let itemsToSubmit = specificItems;

        if (!itemsToSubmit) {
            itemsToSubmit = this.state.selectedItems.length > 0 ?
                this.state.itemslist.filter(item => this.state.selectedItems.includes(item.id)) :
                this.state.itemslist;
        }

        if (itemsToSubmit.length === 0) {
            Swal.fire({
                title: "No Items Selected",
                text: "Please select valid items to add or upload items first",
                icon: "warning",
                confirmButtonText: "Ok",
            });
            return;
        }

        const itemCodes = itemsToSubmit.map(item => item.itemcode);
        const duplicates = this.findDuplicates(itemCodes);
        if (duplicates.length > 0) {
            Swal.fire({
                title: "Duplicate Item Codes Found",
                html: `The following item codes are duplicated and cannot be saved:<br><strong>${duplicates.join(', ')}</strong><br>Please fix the duplicates before proceeding.`,
                icon: "error",
                confirmButtonText: "Ok",
            });
            return;
        }

        const itemsForSubmission = itemsToSubmit.map(item => this.prepareItemObject(item, 'bulk'));

        const totalItems = itemsForSubmission.length;
        const chunkSize = 50;
        let processedItems = 0;
        let successfulCount = 0;
        let finalItemsList = [...this.state.itemslist];

        this.setState({ submissionStatus: 'submitting', submissionProgress: 0 });

        const progressSwal = Swal.fire({
            title: 'Saving Items...',
            html: `
                <div style="text-align: left; margin-top: 10px;">
                    <div id="progress-text">Processing ${totalItems} items...</div>
                    <div style="width: 100%; background: #e0e0e0; border-radius: 4px; margin-top: 10px; height: 10px;">
                        <div id="progress-bar" style="width: 0%; height: 100%; background: #1976d2; border-radius: 4px; transition: width 0.3s;"></div>
                    </div>
                    <div id="progress-detail" style="font-size: 0.8rem; color: #666; margin-top: 5px;">0% completed</div>
                </div>
            `,
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            for (let i = 0; i < totalItems; i += chunkSize) {
                const chunk = itemsForSubmission.slice(i, i + chunkSize);
                const chunkSourceIds = chunk.map(c => c._sourceId);

                const cleanChunk = chunk.map(({ _sourceId, ...rest }) => rest);

                await InventoryService.Addmultipleitems(cleanChunk);

                processedItems += chunk.length;
                successfulCount += chunk.length;

                finalItemsList = finalItemsList.filter(item => !chunkSourceIds.includes(item.id));
                const updatedFilesChunk = this.state.uploadedFiles.map(file => ({
                    ...file,
                    items: file.items.filter(item => finalItemsList.some(fi => fi.id === item.id))
                })).filter(file => file.items.length > 0);

                const progress = Math.round((processedItems / totalItems) * 100);

                this.setState({
                    submissionProgress: progress,
                    itemslist: finalItemsList,
                    uploadedFiles: updatedFilesChunk
                });

                const progressBar = document.getElementById('progress-bar');
                const progressText = document.getElementById('progress-text');
                const progressDetail = document.getElementById('progress-detail');

                if (progressBar) progressBar.style.width = `${progress}%`;
                if (progressText) progressText.innerText = `Saving ${totalItems === 1 ? 'item' : 'items'} (${processedItems}/${totalItems})...`;
                if (progressDetail) progressDetail.innerText = `${progress}% completed`;
            }

            const updatedFiles = this.state.uploadedFiles.map(file => ({
                ...file,
                items: file.items.filter(item => finalItemsList.some(fi => fi.id === item.id))
            })).filter(file => file.items.length > 0);

            this.setState({
                selectedItems: [],
                submissionStatus: 'completed'
            }, () => {
                this.validateBulkItems();

                Swal.fire({
                    title: `Submission Successful`,
                    text: `${successfulCount} ${successfulCount === 1 ? 'item has' : 'items have'} been added. ${finalItemsList.length > 0 ? `${finalItemsList.length} ${finalItemsList.length === 1 ? 'item' : 'items'} with issues ${finalItemsList.length === 1 ? 'remains' : 'remain'} for review.` : ''}`,
                    icon: "success",
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#1976d2",
                }).then(() => {
                    if (finalItemsList.length === 0) {
                        this.props.navigate(-1);
                    }
                });
            });

        } catch (error) {
            console.error("Bulk Submission Error:", error);
            this.setState({ submissionStatus: 'error' });

            Swal.fire({
                title: "Error During Submission",
                text: error.response?.data?.message || "An unexpected error occurred while saving items.",
                icon: "error",
                confirmButtonText: "Ok",
            });
        }
    }

    gethsn = () => {
        this.setState({ hsnloader: true });
        let hsn = this.state.hsn;
        MasterService.getHSNbyCode(hsn).then((response) => {
            let tax = response.data.map(e => e.gst).toLocaleString();
            this.setState({ tax: parseFloat(tax * 100), hsnloader: false });
        }).catch(() => {
            this.setState({ hsnloader: false });
            Swal.fire({
                title: "HSN Code Error",
                text: "Unable to fetch tax rate for this HSN code",
                icon: "warning",
                confirmButtonText: "Ok",
                confirmButtonColor: "#1976d2",
            });
        });
    };

    onfocus() {
        const taxInput = document.getElementById('tax');
        if (taxInput) {
            taxInput.addEventListener('mousewheel', function (event) {
                if (window.document.activeElement.type === 'number') {
                    event.preventDefault();
                }
            });
            taxInput.addEventListener('keydown', function (e) {
                if (e.which === 38 || e.which === 40) {
                    e.preventDefault();
                }
            });
        }
    }

    componentDidMount() {
        if (userid === undefined) {
            Swal.fire({
                title: "Session Expired",
                text: "Your Session is Lost: Please login Back to resume",
                icon: "warning",
                confirmButtonText: "Ok",
                confirmButtonColor: "#1976d2",
            }).then(() => this.props.navigate('/'));
            return;
        }

        const { id, iseditable } = this.props.location.state;

        // Load parallel data
        InventoryService.getLedger(currentTenant)
            .then((response) => this.setState({ ledgerlist: response.data }))
            .catch((e) => {
                if (e.response?.data?.error === "Unauthorized") {
                    Swal.fire({
                        title: "Session Expired",
                        text: "Your Session is Lost: Please login Back to resume",
                        icon: "error",
                        confirmButtonText: "Ok",
                        confirmButtonColor: "#1976d2",
                    }).then(() => this.props.navigate('/'));
                }
            });

        UomServices.getUOM(currentTenant).then((response) => {
            const uniqueUom = [];
            const seen = new Set();
            (response.data || []).forEach(u => {
                if (u.id && !seen.has(u.id)) {
                    seen.add(u.id);
                    uniqueUom.push(u);
                }
            });
            this.setState({ UOMList: uniqueUom });
        });

        SettingsServices.GetSettings(currentTenant).then((response) =>
            this.setState({ additionalparamsforitem: response.data.additionalparamsforitem })
        );

        BrandsServices.getBrands(currentTenant).then((response) => {
            const uniqueBrands = [];
            const seen = new Set();
            (response.data || []).forEach(b => {
                if (b.id && !seen.has(b.id)) {
                    seen.add(b.id);
                    uniqueBrands.push(b);
                }
            });
            this.setState({ brandsList: uniqueBrands });
        });

        CategoryServices.getMainCategory(currentTenant).then((response) => {
            this.setState(
                {
                    mCategoryList: response.data.filter((e) => e.categorytype === "Product"),
                },
                () => {
                    if (id > 0) {
                        InventoryService.retriveItem(id).then((response) => {
                            const item = response.data;

                            this.setState(
                                {
                                    id,
                                    itemname: item.name,
                                    itemcode: item.itemcode,
                                    hsn: item.hsn,
                                    hsnid: item.hsn,
                                    tax: item.tax,
                                    uomid: item.uomid,
                                    uom: item.uomname,
                                    categorytype: item.cattypeid,
                                    category: item.category,
                                    catid: item.catid,
                                    category2: item.category2,
                                    catid2: item.catid2,
                                    mcategory: item.mcategory,
                                    mcatid: item.mcatid,
                                    parameters: item.parameters === 0 ? false : true,
                                    description: item.description,
                                    brand: item.brand,
                                    brandid: item.brandid,
                                    model: item.model,
                                    iseditable: iseditable,
                                },
                                () => {
                                    const mcat = this.state.mCategoryList.find(
                                        (e) => e.id === this.state.mcatid
                                    );
                                    if (mcat) {
                                        this.setState({ CategoryList2: mcat.categorylvltwo || [] }, () => {
                                            const subcat = this.state.CategoryList2.find(
                                                (e) => e.id === this.state.catid2
                                            );
                                            if (subcat) {
                                                this.setState({ CategoryList: subcat.category || [] });
                                            }
                                        });
                                    }
                                }
                            );
                        });
                    }
                }
            );
        });
    }

    setHovered = (value) => {
        this.setState({ hovered: value });
    };

    render() {
        let mCategoryList = this.state.mCategoryList;
        let UOMList = this.state.UOMList;
        let {
            id, itemname, itemcode, hsn, category, catid, category2, catid2,
            mcategory, mcatid, CategoryList2, CategoryList, uom, uomid, tax,
            parameters, description, model, errors
        } = this.state;

        const hovered = this.state.hovered;
        const totalItems = this.state.itemslist.length;
        const selectedCount = this.state.selectedItems.length;
        const hasDuplicates = this.state.duplicateItemCodes.length > 0;
        const hasValidationErrors = Object.keys(this.state.validationErrors).length > 0;
        const hasMappingErrors = this.state.mappingErrors.length > 0;
        const showValidationSummary = this.state.showValidationSummary;

        const duplicateSet = new Set(this.state.duplicateItemCodes);
        const hasValidItems = this.state.itemslist.some(item =>
            !this.state.validationErrors[item.id] && !duplicateSet.has(item.itemcode)
        );

        return (
            <div>
                {this.state.loader && (
                    <div className="UI-loading-overlay">
                        <div className="UI-spinner"></div>
                    </div>
                )}

                {this.state.fileUploadLoading && (
                    <div className="UI-loading-overlay" style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
                        <div className="UI-spinner"></div>
                        <div style={{ marginTop: '20px', color: '#4d4d4d', fontSize: '0.9rem' }}>
                            Parsing file... {this.state.fileUploadProgress}%
                        </div>
                    </div>
                )}

                <div className="UI-container">
                    <div className="UI-card">
                        <div className="UI-header">
                        <Breadcrumb breadcrumbs={[{name:"Home",path:"/inventory"},{name:"Items/Products",path:"/items"},{name:id < 1 ? 'New Item/Product' : 'Edit Item/Product',path:null}]}/>
                            <div className="UI-header-content">
                                <div>
                                    <h1 className="UI-title">
                                        {this.state.id < 1 ? 'Add New Item/Product' : 'Edit Item/Product'}
                                    </h1>
                                    <p className="UI-subtitle">
                                        {this.state.id < 1 ? 'Create a new inventory item' : 'Modify existing item details'}
                                    </p>
                                </div>
                                <div className="UI-header-actions">
                                    <button
                                        onClick={this.handleCancel}
                                        className={`UI-btn UI-btn-outline ${this.state.hovered === "back" ? "UI-btn-outline-hover" : ""}`}
                                        style={{
                                            textDecoration: 'none',
                                            backgroundColor: this.state.hovered === "back" ? "#4d4d4d" : "#ffffff",
                                            color: this.state.hovered === "back" ? "#fff" : "#4d4d4d",
                                            transform: this.state.hovered === "back" ? "scale(1.02)" : "scale(1)",
                                            border: '1px solid #4d4d4d',
                                            cursor: 'pointer'
                                        }}
                                        onMouseEnter={() => this.setState({ hovered: "back" })}
                                        onMouseLeave={() => this.setState({ hovered: null })}
                                    >
                                        ← Back
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="UI-form-container">
                            <form onSubmit={this.handleSubmit}>
                                {/* Entry Type Switch */}
                                {id < 1 && (
                                    <div className="UI-switch-container">
                                        <span className="UI-switch-label">Entry Mode</span>

                                        <div
                                            className="tw-flex"
                                            style={{ alignItems: "center", gap: "20px" }}
                                        >
                                            {/* Manual */}
                                            <div
                                                className="tw-flex cursor-pointer tw-cursor-pointer"
                                                style={{ alignItems: "center", gap: "8px" }}
                                                onClick={() => this.setState({ entrytype: "manual" })}
                                            >
                                                <SelectableRadio
                                                    checked={this.state.entrytype === "manual"}
                                                    size="md"
                                                />
                                                <span style={{ fontSize: "13px", color: "#1e293b" }}>
                                                    Manual Entry
                                                </span>
                                            </div>

                                            {/* Bulk */}
                                            <div
                                                className="tw-flex tw-cursor-pointer"
                                                style={{ alignItems: "center", gap: "8px" }}
                                                onClick={() => this.setState({ entrytype: "bulk" })}
                                            >
                                                <SelectableRadio
                                                    checked={this.state.entrytype === "bulk"}
                                                    size="md"
                                                />
                                                <span style={{ fontSize: "13px", color: "#1e293b" }}>
                                                    Bulk Upload
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                )}

                                {this.state.entrytype === 'manual' ? (
                                    <>
                                        {/* Basic Information */}
                                        <div className="UI-form-section UI-dashed-border tw-p-4 !tw-mb-2">
                                            <h3 className="UI-section-title" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '6px' }}>Basic Information</h3>
                                            <div className="UI-form-grid">
                                                <div className="UI-form-group">
                                                    <TextfieldComponent
                                                        name="itemname"
                                                        type="text"
                                                        label={"Item Name"}
                                                        value={this.state.itemname}
                                                        onChange={(e) => {
                                                            this.setState({
                                                                itemname: e.target.value,
                                                                errors: { ...this.state.errors, itemname: null }
                                                            });
                                                        }}
                                                        disabled={!this.state.iseditable}
                                                        placeholder="Enter item name"
                                                        required
                                                        error={errors.itemname}
                                                    />
                                                </div>

                                                <div className="UI-form-group">
                                                    <TextfieldComponent
                                                        type="text"
                                                        label={"Item Code"}
                                                        value={this.state.itemcode}
                                                        onChange={(e) => this.setState({
                                                            itemcode: e.target.value,
                                                            errors: { ...this.state.errors, itemcode: null }
                                                        })}
                                                        disabled={!this.state.iseditable}
                                                        placeholder="Enter unique item code"
                                                        required
                                                        error={errors.itemcode}
                                                    />
                                                </div>

                                                {ccountry === "India" && (
                                                    <div className="UI-form-group">
                                                        <div className="tw-flex tw-items-center tw-gap-2">
                                                            <div className="tw-w-2/3">
                                                        <TextfieldComponent
                                                            type="text"
                                                            label={"HSN Code"}
                                                            value={this.state.hsn}
                                                                onChange={(e) => {
                                                                    this.setState({
                                                                        hsn: e.target.value,
                                                                        errors: { ...this.state.errors, hsn: null }
                                                                    });
                                                                }}
                                                                fullWidth
                                                                disabled={!this.state.iseditable}
                                                                placeholder="Enter HSN code (optional)"
                                                                error={errors.hsn}

                                                            />
                                                            </div>
                                                            {this.state.iseditable && (
                                                                <button
                                                                    type="button"
                                                                    onClick={this.gethsn}
                                                                    className={`UI-btn UI-btn-outline tw-mt-4 tw-px-6 `}
                                                                    style={{padding: '6px 16px',}}
                                                                    disabled={this.state.hsnloader || !this.state.hsn}
                                                                >
                                                                    {this.state.hsnloader ? 'Fetching...' : 'Fetch Tax'}
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="UI-form-group">
                                                    <TextfieldComponent
                                                        id="tax"
                                                        name="tax"
                                                        type="number"
                                                        label={"Tax Rate (%)"}
                                                        value={this.state.tax}
                                                        onChange={(e) => this.setState({
                                                            tax: parseFloat(e.target.value) || 0,
                                                        })}
                                                        disabled={!this.state.iseditable}
                                                        onFocus={this.onfocus}
                                                        placeholder="0.00 (optional)"
                                                        min="0"
                                                        step="0.1"
                                                        error={errors?.tax}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Category Information */}
                                        <div className="UI-form-section UI-dashed-border tw-p-4 !tw-mb-2">
                                            <h3 className="UI-section-title" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '6px' }}>Category Information</h3>
                                            <div className="UI-form-grid">
                                                <div className="UI-form-group">
                                                    <label className="UI-label">Main Category *</label>
                                                    <Autocomplete
                                                        options={mCategoryList}
                                                        getOptionLabel={(option) => option.category || ''}
                                                        value={mCategoryList.find(cat => cat.id === this.state.mcatid) || null}
                                                        onChange={(event, newValue) => {
                                                            if (newValue && newValue.inputValue === 'add-new') {
                                                                this.handleAddNewCategory();
                                                            } else {
                                                                this.handleCategory(event, newValue);
                                                            }
                                                        }}
                                                        disabled={!this.state.iseditable}
                                                        filterOptions={(options, params) => {
                                                            const filtered = options.filter(opt =>
                                                                opt.category.toLowerCase().includes(params.inputValue.toLowerCase())
                                                            );
                                                            if (appmasterid === "2" || appmasterid === "3") {
                                                                filtered.unshift({
                                                                    inputValue: 'add-new',
                                                                    category: '+ Add New Category',
                                                                });
                                                            }
                                                            return filtered;
                                                        }}
                                                        renderOption={(props, option) => {
                                                            const isAddNew = option.inputValue === 'add-new';
                                                            return (
                                                                <li
                                                                    {...props}
                                                                    style={{
                                                                        fontWeight: isAddNew ? 'bold' : 'normal',
                                                                        color: isAddNew ? '#4d4d4d' : 'inherit',
                                                                        transition: 'transform 0.01s ease',
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        if (isAddNew) e.currentTarget.style.transform = 'scale(1.02)';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        if (isAddNew) e.currentTarget.style.transform = 'scale(1)';
                                                                    }}
                                                                >
                                                                    {option.category}
                                                                </li>
                                                            );
                                                        }}
                                                        renderInput={(params) => (
                                                            <div ref={params.InputProps.ref}>
                                                                <input
                                                                    type="text"
                                                                    {...params.inputProps}
                                                                    className={`UI-input ${errors.mcategory ? 'UI-input-error' : ''} ${!this.state.iseditable ? 'UI-input-disabled' : ''}`}
                                                                    placeholder="Select main category"
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                    {errors.mcategory && (
                                                        <div className="UI-error-text">{errors.mcategory}</div>
                                                    )}
                                                </div>

                                                {/* Always show Sub Category if main category is selected */}
                                                {this.state.mcatid && (
                                                    <div className="UI-form-group">
                                                        <label className="UI-label">Sub Category {CategoryList2.length > 0 ? '*' : ''}</label>
                                                        <Autocomplete
                                                            options={CategoryList2}
                                                            getOptionLabel={(option) => option.name || ''}
                                                            value={CategoryList2.find(cat => cat.id === this.state.catid2) || null}
                                                            onChange={(event, newValue) => {
                                                                if (newValue && newValue.inputValue === 'add-new') {
                                                                    this.handleAddNewSubCategory();
                                                                } else {
                                                                    this.handleCategory2(event, newValue);
                                                                }
                                                            }}
                                                            disabled={!this.state.iseditable}
                                                            filterOptions={(options, params) => {
                                                                const filtered = options.filter(opt =>
                                                                    opt.name.toLowerCase().includes(params.inputValue.toLowerCase())
                                                                );
                                                                if (appmasterid === "2" || appmasterid === "3") {
                                                                    filtered.unshift({
                                                                        inputValue: 'add-new',
                                                                        name: '+ Add New Sub Category',
                                                                    });
                                                                }
                                                                return filtered;
                                                            }}
                                                            renderOption={(props, option) => {
                                                                const isAddNew = option.inputValue === 'add-new';
                                                                return (
                                                                    <li
                                                                        {...props}
                                                                        style={{
                                                                            fontWeight: isAddNew ? 'bold' : 'normal',
                                                                            color: isAddNew ? '#4d4d4d' : 'inherit',
                                                                            transition: 'transform 0.01s ease',
                                                                        }}
                                                                        onMouseEnter={(e) => {
                                                                            if (isAddNew) e.currentTarget.style.transform = 'scale(1.02)';
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            if (isAddNew) e.currentTarget.style.transform = 'scale(1)';
                                                                        }}
                                                                    >
                                                                        {option.name}
                                                                    </li>
                                                                );
                                                            }}
                                                            renderInput={(params) => (
                                                                <div ref={params.InputProps.ref}>
                                                                    <input
                                                                        type="text"
                                                                        {...params.inputProps}
                                                                        className={`UI-input ${errors.category2 ? 'UI-input-error' : ''} ${!this.state.iseditable ? 'UI-input-disabled' : ''}`}
                                                                        placeholder={CategoryList2.length > 0 ? "Select sub category" : "No sub categories - click to add new"}
                                                                    />
                                                                </div>
                                                            )}
                                                        />
                                                        {errors.category2 && (
                                                            <div className="UI-error-text">{errors.category2}</div>
                                                        )}
                                                    </div>
                                                )}

                                                {/* Always show Category Level 3 if sub category is selected */}
                                                {this.state.catid2 && (
                                                    <div className="UI-form-group">
                                                        <label className="UI-label">Category Level 3 {CategoryList.length > 0 ? '*' : ''}</label>
                                                        <Autocomplete
                                                            options={CategoryList}
                                                            getOptionLabel={(option) => option.category || ''}
                                                            value={CategoryList.find(cat => cat.id === this.state.catid) || null}
                                                            onChange={(event, newValue) => {
                                                                if (newValue && newValue.inputValue === 'add-new') {
                                                                    this.handleAddNewCategoryLevel3();
                                                                } else {
                                                                    this.handleCategory3(event, newValue);
                                                                }
                                                            }}
                                                            disabled={!this.state.iseditable}
                                                            filterOptions={(options, params) => {
                                                                const filtered = options.filter(opt =>
                                                                    opt.category.toLowerCase().includes(params.inputValue.toLowerCase())
                                                                );
                                                                if (appmasterid === "2" || appmasterid === "3") {
                                                                    filtered.unshift({
                                                                        inputValue: 'add-new',
                                                                        category: '+ Add New Category Level 3',
                                                                    });
                                                                }
                                                                return filtered;
                                                            }}
                                                            renderOption={(props, option) => {
                                                                const isAddNew = option.inputValue === 'add-new';
                                                                return (
                                                                    <li
                                                                        {...props}
                                                                        style={{
                                                                            fontWeight: isAddNew ? 'bold' : 'normal',
                                                                            color: isAddNew ? '#4d4d4d' : 'inherit',
                                                                            transition: 'transform 0.01s ease',
                                                                        }}
                                                                        onMouseEnter={(e) => {
                                                                            if (isAddNew) e.currentTarget.style.transform = 'scale(1.02)';
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            if (isAddNew) e.currentTarget.style.transform = 'scale(1)';
                                                                        }}
                                                                    >
                                                                        {option.category}
                                                                    </li>
                                                                );
                                                            }}
                                                            renderInput={(params) => (
                                                                <div ref={params.InputProps.ref}>
                                                                    <input
                                                                        type="text"
                                                                        {...params.inputProps}
                                                                        className={`UI-input ${errors.category ? 'UI-input-error' : ''} ${!this.state.iseditable ? 'UI-input-disabled' : ''}`}
                                                                        placeholder={CategoryList.length > 0 ? "Select category level 3" : "No categories - click to add new"}
                                                                    />
                                                                </div>
                                                            )}
                                                        />
                                                        {errors.category && (
                                                            <div className="UI-error-text">{errors.category}</div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        

                                        {/* Product Details */}
                                        <div className="UI-form-section UI-dashed-border tw-p-4">
                                            <h3 className="UI-section-title" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '6px' }}>Other Details</h3>
                                            <div className="UI-form-grid">
                                                <div className="UI-form-group">
                                                    <label className="UI-label">Brand</label>
                                                    <Autocomplete
                                                        options={this.state.brandsList}
                                                        getOptionLabel={(option) => option.brand || ''}
                                                        isOptionEqualToValue={(option, value) => String(option.id) === String(value?.id)}
                                                        value={this.state.brandid ? (this.state.brandsList.find(brand => String(brand.id) === String(this.state.brandid)) || null) : null}
                                                        onChange={(event, newValue) => {
                                                            if (newValue && newValue.inputValue === 'add-new') {
                                                                this.handleAddNewBrand();
                                                            } else {
                                                                this.handlebrand(event, newValue);
                                                            }
                                                        }}
                                                        disabled={!this.state.iseditable}
                                                        filterOptions={(options, params) => {
                                                            const filtered = options.filter(opt =>
                                                                (opt.brand || '').toLowerCase().includes((params.inputValue || '').toLowerCase())
                                                            );
                                                            if (appmasterid === "2" || appmasterid === "3") {
                                                                filtered.unshift({
                                                                    inputValue: 'add-new',
                                                                    brand: '+ Add New Brand',
                                                                });
                                                            }
                                                            return filtered;
                                                        }}
                                                        renderOption={(props, option) => {
                                                            const isAddNew = option.inputValue === 'add-new';
                                                            return (
                                                                <li
                                                                    {...props}
                                                                    style={{
                                                                        fontWeight: isAddNew ? 'bold' : 'normal',
                                                                        color: isAddNew ? '#4d4d4d' : 'inherit',
                                                                        transition: 'transform 0.01s ease',
                                                                    }}
                                                                >
                                                                    {option.brand}
                                                                </li>
                                                            );
                                                        }}
                                                        renderInput={(params) => (
                                                            <div ref={params.InputProps.ref}>
                                                                <input
                                                                    type="text"
                                                                    {...params.inputProps}
                                                                    className={`UI-input ${!this.state.iseditable ? 'UI-input-disabled' : ''}`}
                                                                    placeholder="Select brand"
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                </div>

                                                <div className="UI-form-group">
                                                    <label className="UI-label">Model</label>
                                                    <TextfieldComponent
                                                        type="text"
                                                        value={this.state.model}
                                                        onChange={(e) => this.setState({ model: e.target.value })}
                                                        disabled={!this.state.iseditable}
                                                        placeholder="Enter model"
                                                    />
                                                </div>

                                                <div className="UI-form-group">
                                                    <label className="UI-label">Unit of Measurement *</label>
                                                    <Autocomplete
                                                        options={UOMList}
                                                        getOptionLabel={(option) => option.name || ''}
                                                        isOptionEqualToValue={(option, value) => String(option.id) === String(value?.id)}
                                                        value={this.state.uomid ? (UOMList.find(uom => String(uom.id) === String(this.state.uomid)) || null) : null}
                                                        onChange={(event, newValue) => {
                                                            if (newValue && newValue.inputValue === 'add-new') {
                                                                this.handleAddNewUom();
                                                            } else {
                                                                this.handleUOM(event, newValue);
                                                            }
                                                        }}
                                                        disabled={!this.state.iseditable}
                                                        filterOptions={(options, params) => {
                                                            const filtered = options.filter(opt =>
                                                                (opt.name || '').toLowerCase().includes((params.inputValue || '').toLowerCase())
                                                            );
                                                            if (appmasterid === "2" || appmasterid === "3") {
                                                                filtered.unshift({
                                                                    inputValue: 'add-new',
                                                                    name: '+ Add New UOM',
                                                                });
                                                            }
                                                            return filtered;
                                                        }}
                                                        renderOption={(props, option) => {
                                                            const isAddNew = option.inputValue === 'add-new';
                                                            return (
                                                                <li
                                                                    {...props}
                                                                    style={{
                                                                        fontWeight: isAddNew ? 'bold' : 'normal',
                                                                        color: isAddNew ? '#4d4d4d' : 'inherit',
                                                                        transition: 'transform 0.01s ease',
                                                                    }}
                                                                >
                                                                    {option.name}
                                                                </li>
                                                            );
                                                        }}
                                                        renderInput={(params) => (
                                                            <div ref={params.InputProps.ref}>
                                                                <input
                                                                    type="text"
                                                                    {...params.inputProps}
                                                                    className={`UI-input ${errors.uom ? 'UI-input-error' : ''} ${!this.state.iseditable ? 'UI-input-disabled' : ''}`}
                                                                    placeholder="Select unit of measurement"
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                    {errors.uom && (
                                                        <div className="UI-error-text">{errors.uom}</div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="UI-form-group">
                                                {/* <label className="UI-label">Description *</label> */}
                                                <TextareaField
                                                label="Description"
                                                    value={this.state.description}
                                                    onChange={(e) => this.setState({
                                                        description: e.target.value,
                                                        errors: { ...this.state.errors, description: null }
                                                    })}
                                                    className={`UI-textarea ${errors.description ? 'UI-input-error' : ''} ${!this.state.iseditable ? 'UI-input-disabled' : ''}`}
                                                    disabled={!this.state.iseditable}
                                                    placeholder="Enter detailed item description"
                                                    error={errors.description}
                                                    maxLength={250}
                                                    required
                                                />
                                            </div>

                                            {this.state.additionalparamsforitem === 'YES' && (
                                                <div className="UI-form-group">
                                                    <label
                                                        className="UI-checkbox"
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px",
                                                            cursor: this.state.iseditable ? "pointer" : "not-allowed",
                                                        }}
                                                        onClick={() => {
                                                            if (!this.state.iseditable) return
                                                            this.handleparameters({
                                                                target: { checked: !this.state.parameters },
                                                            })
                                                        }}
                                                    >
                                                        <SelectableRadio
                                                            checked={this.state.parameters}
                                                            size="md"
                                                        />

                                                        <span>
                                                            Do You Need Additional Parameters? (Colour, Thickness, Size, TotalMtrRoll)
                                                            {this.state.parameters && (
                                                                <span style={{ color: "#5f8f3fff", marginLeft: "6px" }}>
                                                                    ✔ Parameters will be available during Sales/invoicing/Purchase.
                                                                </span>
                                                            )}
                                                        </span>
                                                    </label>
                                                </div>

                                            )}

                                        </div>
                                    </>
                                ) : (
                                    <div className="UI-form-section">
                                        <h3 className="UI-section-title" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '6px' }}>Bulk Upload</h3>

                                        {/* 1. Download Template */}
                                        <div className="UI-form-group">
                                            <button
                                                type="button"
                                                onClick={this.downloadExcel}
                                                className={`UI-btn UI-btn-success ${this.state.hovered === "downloadExcel" ? "UI-btn-success-hover" : ""}`}
                                                style={{
                                                    transform: this.state.hovered === "downloadExcel" ? "scale(1.05)" : "scale(1)",
                                                }}
                                                onMouseEnter={() => this.setState({ hovered: "downloadExcel" })}
                                                onMouseLeave={() => this.setState({ hovered: null })}
                                            >
                                                📥 Download Sample Excel
                                            </button>
                                            <div className="UI-helper-text">
                                                Download the Sample Excel template, fill in your items data, and upload it back.
                                                Template includes: Item Name*, Item Code*, HSN Code, Tax Rate (%), Model, Description*
                                            </div>
                                        </div>

                                        {/* 2. Upload Section */}
                                        <div className="UI-form-group">
                                            <label className="UI-label">Upload Excel File(s)</label>
                                            <div
                                                className={`UI-file-upload-area ${this.state.hovered === "uploadExcel" ? "UI-file-upload-active" : ""
                                                    }`}
                                                style={{
                                                    transform: this.state.hovered === "uploadExcel" ? "scale(1.01)" : "scale(1)",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    textAlign: "center",
                                                    position: 'relative'
                                                }}
                                                onClick={() => this.fileInputRef.click()}
                                                onMouseEnter={() => this.setState({ hovered: "uploadExcel" })}
                                                onMouseLeave={() => this.setState({ hovered: null })}
                                            >
                                                <input
                                                    type="file"
                                                    accept=".xlsx,.xls"
                                                    ref={(ref) => (this.fileInputRef = ref)}
                                                    className="UI-file-upload-input"
                                                    onChange={async (e) => {
                                                        const files = Array.from(e.target.files);
                                                        for (const file of files) {
                                                            await this.readExcel(file);
                                                        }
                                                        e.target.value = '';
                                                    }}
                                                    multiple
                                                />

                                                <div style={{ fontSize: "0.85rem", fontWeight: 500 }}>
                                                    Click to upload Excel file(s)
                                                </div>

                                                <div style={{ marginTop: "6px", fontSize: "0.7rem", color: "#64748b" }}>
                                                    Supported formats: .xlsx, .xls (Max 5MB per file)
                                                </div>
                                            </div>
                                        </div>

                                        {/* 3. Uploaded Files */}
                                        {this.state.uploadedFiles.length > 0 && (
                                            <div className="UI-form-group">
                                                <label className="UI-label">Uploaded Files ({this.state.uploadedFiles.length})</label>
                                                <div className="UI-uploaded-files-list">
                                                    {this.state.uploadedFiles.map(file => (
                                                        <div key={file.id} className="UI-uploaded-file-item">
                                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                                                <span style={{ fontSize: '0.8rem', fontWeight: '500' }}>
                                                                    📄 {file.name}
                                                                </span>
                                                                <span style={{ fontSize: '0.7rem', color: '#64748b' }}>
                                                                    {file.items.length} items • {Math.round(file.size / 1024)} KB
                                                                </span>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                onClick={() => this.removeFile(file.id)}
                                                                className={`UI-btn UI-btn-outline ${this.state.hovered === `remove-${file.id}` ? "UI-btn-outline-hover" : ""}`}
                                                                style={{
                                                                    padding: '2px 8px',
                                                                    fontSize: '0.7rem',
                                                                    minHeight: 'auto',
                                                                    minWidth: '30px',
                                                                    transform: this.state.hovered === `remove-${file.id}` ? "scale(1.05)" : "scale(1)",
                                                                }}
                                                                onMouseEnter={() => this.setState({ hovered: `remove-${file.id}` })}
                                                                onMouseLeave={() => this.setState({ hovered: null })}
                                                            >
                                                                ×
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        {/* 4. Bulk Field Mapping Section with Parameters */}
                                        {this.state.itemslist.length > 0 && (
                                            <div className="UI-form-section" style={{ backgroundColor: '#f8fafc', padding: '15px', borderRadius: '6px', marginBottom: '15px' }}>
                                                <div style={{ marginBottom: '16px' }}>
                                                    <div
                                                        style={{
                                                            padding: '12px',
                                                            borderRadius: '6px',
                                                            display: 'flex',
                                                            alignItems: 'flex-start',
                                                            gap: '10px',
                                                            backgroundColor: '#eff6ff'
                                                        }}
                                                    >
                                                        {/* Info Icon */}
                                                        <div
                                                            style={{
                                                                width: '20px',
                                                                height: '20px',
                                                                borderRadius: '50%',
                                                                backgroundColor: '#2563eb',
                                                                color: '#fff',
                                                                fontSize: '12px',
                                                                fontWeight: 'bold',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                flexShrink: 0,
                                                            }}
                                                        >
                                                            i
                                                        </div>

                                                        {/* Text */}
                                                        <div
                                                            style={{
                                                                fontSize: '0.8rem',
                                                                color: '#1e40af',
                                                                lineHeight: '1.4'
                                                            }}
                                                        >
                                                            Set common attributes for all uploaded items here. These values will be applied as defaults to every item
                                                            in your list, saving you repetitive work. You can still override these for specific items in the table below.
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="UI-form-grid">
                                                    <div className="UI-form-group">
                                                        <label className="UI-label">Main Category *</label>
                                                        <Autocomplete
                                                            options={mCategoryList}
                                                            getOptionLabel={(option) => option.category || ''}
                                                            value={mCategoryList.find(cat => cat.category === this.state.bulkFieldMappings.mcategory) || null}
                                                            onChange={this.handleBulkMainCategory}
                                                            filterOptions={(options, params) => {
                                                                const filtered = options.filter(opt =>
                                                                    opt.category.toLowerCase().includes(params.inputValue.toLowerCase())
                                                                );
                                                                if (appmasterid === "2" || appmasterid === "3") {
                                                                    filtered.unshift({
                                                                        inputValue: 'add-new',
                                                                        category: '+ Add New Category',
                                                                    });
                                                                }
                                                                return filtered;
                                                            }}
                                                            renderOption={(props, option) => {
                                                                const isAddNew = option.inputValue === 'add-new';
                                                                return (
                                                                    <li
                                                                        {...props}
                                                                        style={{
                                                                            fontWeight: isAddNew ? 'bold' : 'normal',
                                                                            color: isAddNew ? '#4d4d4d' : 'inherit',
                                                                            transition: 'transform 0.01s ease',
                                                                        }}
                                                                        onMouseEnter={(e) => {
                                                                            if (isAddNew) e.currentTarget.style.transform = 'scale(1.02)';
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            if (isAddNew) e.currentTarget.style.transform = 'scale(1)';
                                                                        }}
                                                                    >
                                                                        {option.category}
                                                                    </li>
                                                                );
                                                            }}
                                                            renderInput={(params) => (
                                                                <div ref={params.InputProps.ref}>
                                                                    <input
                                                                        type="text"
                                                                        {...params.inputProps}
                                                                        className="UI-input"
                                                                        placeholder="Select main category *"
                                                                    />
                                                                </div>
                                                            )}
                                                        />
                                                    </div>

                                                    {this.state.bulkFieldMappings.mcatid && (
                                                        <div className="UI-form-group">
                                                            <label className="UI-label">Sub Category {this.state.CategoryList2.length > 0 ? '*' : ''}</label>
                                                            <Autocomplete
                                                                options={this.state.CategoryList2}
                                                                getOptionLabel={(option) => option.name || ''}
                                                                value={this.state.CategoryList2.find(cat => cat.name === this.state.bulkFieldMappings.category2) || null}
                                                                onChange={this.handleBulkSubCategory}
                                                                filterOptions={(options, params) => {
                                                                    const filtered = options.filter(opt =>
                                                                        opt.name.toLowerCase().includes(params.inputValue.toLowerCase())
                                                                    );
                                                                    if (appmasterid === "2" || appmasterid === "3") {
                                                                        filtered.unshift({
                                                                            inputValue: 'add-new',
                                                                            name: '+ Add New Sub Category',
                                                                        });
                                                                    }
                                                                    return filtered;
                                                                }}
                                                                renderOption={(props, option) => {
                                                                    const isAddNew = option.inputValue === 'add-new';
                                                                    return (
                                                                        <li
                                                                            {...props}
                                                                            style={{
                                                                                fontWeight: isAddNew ? 'bold' : 'normal',
                                                                                color: isAddNew ? '#4d4d4d' : 'inherit',
                                                                                transition: 'transform 0.01s ease',
                                                                            }}
                                                                            onMouseEnter={(e) => {
                                                                                if (isAddNew) e.currentTarget.style.transform = 'scale(1.02)';
                                                                            }}
                                                                            onMouseLeave={(e) => {
                                                                                if (isAddNew) e.currentTarget.style.transform = 'scale(1)';
                                                                            }}
                                                                        >
                                                                            {option.name}
                                                                        </li>
                                                                    );
                                                                }}
                                                                renderInput={(params) => (
                                                                    <div ref={params.InputProps.ref}>
                                                                        <input
                                                                            type="text"
                                                                            {...params.inputProps}
                                                                            className="UI-input"
                                                                            placeholder={this.state.CategoryList2.length > 0 ? "Select sub category" : "No sub categories - click to add new"}
                                                                        />
                                                                    </div>
                                                                )}
                                                            />
                                                        </div>
                                                    )}

                                                    {this.state.bulkFieldMappings.catid2 && (
                                                        <div className="UI-form-group">
                                                            <label className="UI-label">Category Level 3 {this.state.CategoryList.length > 0 ? '*' : ''}</label>
                                                            <Autocomplete
                                                                options={this.state.CategoryList}
                                                                getOptionLabel={(option) => option.category || ''}
                                                                value={this.state.CategoryList.find(cat => cat.category === this.state.bulkFieldMappings.category) || null}
                                                                onChange={this.handleBulkLevel3Category}
                                                                filterOptions={(options, params) => {
                                                                    const filtered = options.filter(opt =>
                                                                        opt.category.toLowerCase().includes(params.inputValue.toLowerCase())
                                                                    );
                                                                    if (appmasterid === "2" || appmasterid === "3") {
                                                                        filtered.unshift({
                                                                            inputValue: 'add-new',
                                                                            category: '+ Add New Category Level 3',
                                                                        });
                                                                    }
                                                                    return filtered;
                                                                }}
                                                                renderOption={(props, option) => {
                                                                    const isAddNew = option.inputValue === 'add-new';
                                                                    return (
                                                                        <li
                                                                            {...props}
                                                                            style={{
                                                                                fontWeight: isAddNew ? 'bold' : 'normal',
                                                                                color: isAddNew ? '#4d4d4d' : 'inherit',
                                                                                transition: 'transform 0.01s ease',
                                                                            }}
                                                                            onMouseEnter={(e) => {
                                                                                if (isAddNew) e.currentTarget.style.transform = 'scale(1.02)';
                                                                            }}
                                                                            onMouseLeave={(e) => {
                                                                                if (isAddNew) e.currentTarget.style.transform = 'scale(1)';
                                                                            }}
                                                                        >
                                                                            {option.category}
                                                                        </li>
                                                                    );
                                                                }}
                                                                renderInput={(params) => (
                                                                    <div ref={params.InputProps.ref}>
                                                                        <input
                                                                            type="text"
                                                                            {...params.inputProps}
                                                                            className="UI-input"
                                                                            placeholder={this.state.CategoryList.length > 0 ? "Select category level 3" : "No categories - click to add new"}
                                                                        />
                                                                    </div>
                                                                )}
                                                            />
                                                        </div>
                                                    )}

                                                    <div className="UI-form-group">
                                                        <label className="UI-label">UOM *</label>
                                                        <Autocomplete
                                                            options={UOMList}
                                                            getOptionLabel={(option) => option.name || ''}
                                                            isOptionEqualToValue={(option, value) => String(option.id) === String(value?.id)}
                                                            value={UOMList.find(uom => String(uom.id) === String(this.state.bulkFieldMappings.uomid)) || null}
                                                            onChange={(event, newValue) => {
                                                                if (newValue) {
                                                                    if (newValue.inputValue === 'add-new') {
                                                                        this.handleAddNewUom();
                                                                    } else {
                                                                        this.applyMappingToAll({
                                                                            uom: newValue.name,
                                                                            uomid: newValue.id
                                                                        });
                                                                    }
                                                                }
                                                            }}
                                                            filterOptions={(options, params) => {
                                                                const filtered = options.filter(opt =>
                                                                    opt.name.toLowerCase().includes(params.inputValue.toLowerCase())
                                                                );
                                                                if (appmasterid === "2" || appmasterid === "3") {
                                                                    filtered.unshift({
                                                                        inputValue: 'add-new',
                                                                        name: '+ Add New UOM',
                                                                    });
                                                                }
                                                                return filtered;
                                                            }}
                                                            renderOption={(props, option) => {
                                                                const isAddNew = option.inputValue === 'add-new';
                                                                return (
                                                                    <li
                                                                        {...props}
                                                                        style={{
                                                                            fontWeight: isAddNew ? 'bold' : 'normal',
                                                                            color: isAddNew ? '#4d4d4d' : 'inherit',
                                                                            transition: 'transform 0.01s ease',
                                                                        }}
                                                                    >
                                                                        {option.name}
                                                                    </li>
                                                                );
                                                            }}
                                                            renderInput={(params) => (
                                                                <div ref={params.InputProps.ref}>
                                                                    <input
                                                                        type="text"
                                                                        {...params.inputProps}
                                                                        className="UI-input"
                                                                        placeholder="Select UOM *"
                                                                    />
                                                                </div>
                                                            )}
                                                        />
                                                    </div>

                                                    <div className="UI-form-group">
                                                        <label className="UI-label">Brand</label>
                                                        <Autocomplete
                                                            options={this.state.brandsList}
                                                            getOptionLabel={(option) => option.brand || ''}
                                                            isOptionEqualToValue={(option, value) => String(option.id) === String(value?.id)}
                                                            value={this.state.brandsList.find(brand => String(brand.id) === String(this.state.bulkFieldMappings.brandid)) || null}
                                                            onChange={(event, newValue) => {
                                                                if (newValue) {
                                                                    if (newValue.inputValue === 'add-new') {
                                                                        this.handleAddNewBrand();
                                                                    } else {
                                                                        this.applyMappingToAll({
                                                                            brand: newValue.brand,
                                                                            brandid: newValue.id
                                                                        });
                                                                    }
                                                                }
                                                            }}
                                                            filterOptions={(options, params) => {
                                                                const filtered = options.filter(opt =>
                                                                    opt.brand.toLowerCase().includes(params.inputValue.toLowerCase())
                                                                );
                                                                if (appmasterid === "2" || appmasterid === "3") {
                                                                    filtered.unshift({
                                                                        inputValue: 'add-new',
                                                                        brand: '+ Add New Brand',
                                                                    });
                                                                }
                                                                return filtered;
                                                            }}
                                                            renderOption={(props, option) => {
                                                                const isAddNew = option.inputValue === 'add-new';
                                                                return (
                                                                    <li
                                                                        {...props}
                                                                        style={{
                                                                            fontWeight: isAddNew ? 'bold' : 'normal',
                                                                            color: isAddNew ? '#4d4d4d' : 'inherit',
                                                                            transition: 'transform 0.01s ease',
                                                                        }}
                                                                    >
                                                                        {option.brand}
                                                                    </li>
                                                                );
                                                            }}
                                                            renderInput={(params) => (
                                                                <div ref={params.InputProps.ref}>
                                                                    <input
                                                                        type="text"
                                                                        {...params.inputProps}
                                                                        className="UI-input"
                                                                        placeholder="Select brand"
                                                                    />
                                                                </div>
                                                            )}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Parameters for all items */}
                                                {this.state.additionalparamsforitem === 'YES' && (
                                                    <div className="UI-form-group" style={{ marginBottom: '15px' }}>
                                                        <label
                                                            className="UI-checkbox"
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "8px",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => {
                                                                const newValue = !this.state.bulkFieldMappings.parameters;
                                                                this.applyMappingToAll('parameters', newValue);
                                                            }}
                                                        >
                                                            <SelectableRadio
                                                                checked={this.state.bulkFieldMappings.parameters}
                                                                size="md"
                                                            />
                                                            <span>
                                                                Do You Need Additional Parameters for all items? (Colour, Thickness, Size, TotalMtrRoll)
                                                                {this.state.bulkFieldMappings.parameters && (
                                                                    <span style={{ color: "#5f8f3fff", marginLeft: "6px" }}>
                                                                        ✔ Parameters will be available during invoicing for all items.
                                                                    </span>
                                                                )}
                                                            </span>
                                                        </label>
                                                    </div>
                                                )}

                                            </div>
                                        )}

                                        {/* 5. Validation Summary & Preview Table */}
                                        {this.state.itemslist.length > 0 && (
                                            <>
                                                {/* Preview Table Header with Search and Clear All */}
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px', flexWrap: 'wrap', gap: '15px' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                                        <h4 className="UI-section-title" style={{ margin: 0 }}>Preview Items ({this.state.itemslist.length})</h4>

                                                        {/* Search Input */}
                                                        <div style={{ position: 'relative', width: '250px' }}>
                                                            <input
                                                                type="text"
                                                                placeholder="Search name or code..."
                                                                value={this.state.searchFilter}
                                                                onChange={(e) => this.setState({ searchFilter: e.target.value })}
                                                                className="UI-input"
                                                                style={{ padding: '6px 12px', fontSize: '0.8rem', borderRadius: '20px' }}
                                                            />
                                                        </div>

                                                        {(hasDuplicates || hasValidationErrors) && (
                                                            <>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '0.8rem' }}>
                                                                    <SelectableRadio
                                                                        checked={this.state.showOnlyErrors}
                                                                        onClick={() => this.setState({ showOnlyErrors: !this.state.showOnlyErrors, showValidData: false })}
                                                                        size="sm"
                                                                    />
                                                                    <span onClick={() => this.setState({ showOnlyErrors: !this.state.showOnlyErrors, showValidData: false })}>Show Errors Only</span>
                                                                </div>

                                                                {hasValidItems && (
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '0.8rem', marginLeft: '10px' }}>
                                                                        <SelectableRadio
                                                                            checked={this.state.showValidData}
                                                                            onClick={() => this.setState({ showValidData: !this.state.showValidData, showOnlyErrors: false })}
                                                                            size="sm"
                                                                        />
                                                                        <span onClick={() => this.setState({ showValidData: !this.state.showValidData, showOnlyErrors: false })}>Show Valid Data</span>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>

                                                    <button
                                                        type="button"
                                                        onClick={this.clearAll}
                                                        className={`UI-btn UI-btn-danger ${this.state.hovered === "clearAll" ? "UI-btn-danger-hover" : ""}`}
                                                        style={{
                                                            transform: this.state.hovered === "clearAll" ? "scale(1.05)" : "scale(1)",
                                                        }}
                                                        onMouseEnter={() => this.setState({ hovered: "clearAll" })}
                                                        onMouseLeave={() => this.setState({ hovered: null })}
                                                    >
                                                        Clear All
                                                    </button>
                                                </div>

                                                {/* Summary Info */}
                                                <div className="UI-form-group" style={{ marginBottom: '15px' }}>
                                                    <div className="UI-helper-text">
                                                        Total Items: <strong>{this.state.itemslist.length}</strong>
                                                        {selectedCount > 0 && ` • Selected: ${selectedCount}`}
                                                        {this.state.searchFilter && ` • Filtered: ${this.getFilteredItems().length}`}
                                                        {(hasDuplicates || hasValidationErrors || hasMappingErrors) && showValidationSummary && (
                                                            <span style={{ color: '#dc2626', marginLeft: '10px' }}>
                                                                ⚠ Review validation issues before confirming
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Validation Summary - Only shown after clicking confirm */}
                                                {showValidationSummary && (hasDuplicates || hasValidationErrors || hasMappingErrors) && (
                                                    <div className="UI-form-group" style={{ marginBottom: '15px' }}>
                                                        <div style={{
                                                            padding: '12px',
                                                            borderRadius: '6px',
                                                            backgroundColor: '#fef2f2',
                                                            border: '1px solid #fecaca',
                                                        }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '5px' }}>
                                                                <span style={{ color: '#dc2626', fontWeight: '600', fontSize: '0.85rem' }}>
                                                                    ⚠ Validation Issues Found
                                                                </span>
                                                            </div>
                                                            <div style={{ fontSize: '0.8rem', color: '#7f1d1d' }}>
                                                                {this.getValidationSummary().message}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {/* 6. Preview Table */}
                                                <div className="UI-table-container" style={{ borderRadius: '6px', border: '1px solid #e2e8f0', backgroundColor: '#ffffff', maxHeight: '500px', overflowY: 'auto' }}>
                                                    <table className="UI-table">
                                                        <thead className="UI-table-header" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                                            <tr>
                                                                <th className="UI-th">Item Name</th>
                                                                <th className="UI-th">Item Code</th>
                                                                {ccountry === "India" && <th className="UI-th">HSN</th>}
                                                                <th className="UI-th">Tax (%)</th>
                                                                <th className="UI-th">Model</th>
                                                                <th className="UI-th">Main Category</th>
                                                                <th className="UI-th">Sub Category</th>
                                                                <th className="UI-th">Category Level 3</th>
                                                                <th className="UI-th">UOM</th>
                                                                <th className="UI-th">Brand</th>
                                                                <th className="UI-th">Parameters</th>
                                                                <th className="UI-th">Description</th>
                                                                <th className="UI-th">Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.getFilteredItems().map((item, index) => {
                                                                const isDuplicate = this.state.duplicateItemCodes.includes(item.itemcode);
                                                                const hasErrors = this.state.validationErrors[item.id] || (!item.mcategory || !item.uom || !item.name || !item.itemcode || !item.description);
                                                                const isSelected = this.state.selectedItems.includes(item.id);

                                                                return (
                                                                    <tr key={item.id} style={{
                                                                        backgroundColor: index % 2 === 0 ? '#f8fafc' : '#ffffff',
                                                                        borderLeft: isDuplicate ? '3px solid #dc2626' : (hasErrors ? '3px solid #f59e0b' : 'none')
                                                                    }}>
                                                                        {this.state.bulkEditItemId === item.id ? (
                                                                            // Edit Mode - WITH REHYDRATED OBJECTS
                                                                            <>
                                                                                <td className="UI-td">
                                                                                    <input
                                                                                        type="text"
                                                                                        value={this.state.editingItem?.name || ''}
                                                                                        onChange={(e) => this.updateEditField('name', e.target.value)}
                                                                                        className={`UI-input ${hasErrors ? 'UI-input-error' : ''}`}
                                                                                        style={{ width: '100%', fontSize: '0.8rem', padding: '4px' }}
                                                                                    />
                                                                                </td>
                                                                                <td className="UI-td">
                                                                                    <input
                                                                                        type="text"
                                                                                        value={this.state.editingItem?.itemcode || ''}
                                                                                        onChange={(e) => this.updateEditField('itemcode', e.target.value)}
                                                                                        className={`UI-input ${isDuplicate ? 'UI-input-error' : ''}`}
                                                                                        style={{ width: '100%', fontSize: '0.8rem', padding: '4px' }}
                                                                                    />
                                                                                </td>
                                                                                {ccountry === "India" && (
                                                                                    <td className="UI-td">
                                                                                        <input
                                                                                            type="text"
                                                                                            value={this.state.editingItem?.hsn || ''}
                                                                                            onChange={(e) => this.updateEditField('hsn', e.target.value)}
                                                                                            className="UI-input"
                                                                                            style={{ width: '100%', fontSize: '0.8rem', padding: '4px' }}
                                                                                        />
                                                                                    </td>
                                                                                )}
                                                                                <td className="UI-td">
                                                                                    <input
                                                                                        type="number"
                                                                                        value={this.state.editingItem?.tax || ''}
                                                                                        onChange={(e) => this.updateEditField('tax', e.target.value)}
                                                                                        className="UI-input"
                                                                                        style={{ width: '100%', fontSize: '0.8rem', padding: '4px' }}
                                                                                    />
                                                                                </td>
                                                                                <td className="UI-td">
                                                                                    <input
                                                                                        type="text"
                                                                                        value={this.state.editingItem?.model || ''}
                                                                                        onChange={(e) => this.updateEditField('model', e.target.value)}
                                                                                        className="UI-input"
                                                                                        style={{ width: '100%', fontSize: '0.8rem', padding: '4px' }}
                                                                                    />
                                                                                </td>
                                                                                <td className="UI-td">
                                                                                    <Autocomplete
                                                                                        options={mCategoryList}
                                                                                        getOptionLabel={(option) => option.category || ''}
                                                                                        value={this.state.editingItem?._mcategoryObj}
                                                                                        onChange={(event, newValue) => {
                                                                                            this.updateEditField('mcategory', newValue);
                                                                                        }}
                                                                                        filterOptions={(options, params) => {
                                                                                            const filtered = options.filter(opt =>
                                                                                                opt.category.toLowerCase().includes(params.inputValue.toLowerCase())
                                                                                            );
                                                                                            if (appmasterid === "2" || appmasterid === "3") {
                                                                                                filtered.unshift({
                                                                                                    inputValue: 'add-new',
                                                                                                    category: '+ Add New Category',
                                                                                                });
                                                                                            }
                                                                                            return filtered;
                                                                                        }}
                                                                                        renderInput={(params) => (
                                                                                            <div ref={params.InputProps.ref}>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    {...params.inputProps}
                                                                                                    className="UI-input"
                                                                                                    style={{ width: '100%', fontSize: '0.8rem', padding: '4px' }}
                                                                                                    placeholder="Main category"
                                                                                                />
                                                                                            </div>
                                                                                        )}
                                                                                        size="small"
                                                                                    />
                                                                                </td>
                                                                                <td className="UI-td">
                                                                                    <Autocomplete
                                                                                        options={this.state.editSubCategoryList}
                                                                                        getOptionLabel={(option) => option.name || ''}
                                                                                        value={this.state.editingItem?._subcategoryObj}
                                                                                        onChange={(event, newValue) => {
                                                                                            this.updateEditField('category2', newValue);
                                                                                        }}
                                                                                        filterOptions={(options, params) => {
                                                                                            const filtered = options.filter(opt =>
                                                                                                opt.name.toLowerCase().includes(params.inputValue.toLowerCase())
                                                                                            );
                                                                                            if (appmasterid === "2" || appmasterid === "3") {
                                                                                                filtered.unshift({
                                                                                                    inputValue: 'add-new',
                                                                                                    name: '+ Add New Sub Category',
                                                                                                });
                                                                                            }
                                                                                            return filtered;
                                                                                        }}
                                                                                        renderInput={(params) => (
                                                                                            <div ref={params.InputProps.ref}>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    {...params.inputProps}
                                                                                                    className="UI-input"
                                                                                                    style={{ width: '100%', fontSize: '0.8rem', padding: '4px' }}
                                                                                                    placeholder="Sub category"
                                                                                                />
                                                                                            </div>
                                                                                        )}
                                                                                        size="small"
                                                                                        disabled={!this.state.editingItem?.mcategory}
                                                                                    />
                                                                                </td>
                                                                                <td className="UI-td">
                                                                                    <Autocomplete
                                                                                        options={this.state.editLevel3CategoryList}
                                                                                        getOptionLabel={(option) => option.category || ''}
                                                                                        value={this.state.editingItem?._level3Obj}
                                                                                        onChange={(event, newValue) => {
                                                                                            this.updateEditField('category', newValue);
                                                                                        }}
                                                                                        filterOptions={(options, params) => {
                                                                                            const filtered = options.filter(opt =>
                                                                                                opt.category.toLowerCase().includes(params.inputValue.toLowerCase())
                                                                                            );
                                                                                            if (appmasterid === "2" || appmasterid === "3") {
                                                                                                filtered.unshift({
                                                                                                    inputValue: 'add-new',
                                                                                                    category: '+ Add New Category Level 3',
                                                                                                });
                                                                                            }
                                                                                            return filtered;
                                                                                        }}
                                                                                        renderInput={(params) => (
                                                                                            <div ref={params.InputProps.ref}>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    {...params.inputProps}
                                                                                                    className="UI-input"
                                                                                                    style={{ width: '100%', fontSize: '0.8rem', padding: '4px' }}
                                                                                                    placeholder="Category level 3"
                                                                                                />
                                                                                            </div>
                                                                                        )}
                                                                                        size="small"
                                                                                        disabled={!this.state.editingItem?.category2}
                                                                                    />
                                                                                </td>
                                                                                <td className="UI-td">
                                                                                    <Autocomplete
                                                                                        options={UOMList}
                                                                                        getOptionLabel={(option) => option.name || ''}
                                                                                        isOptionEqualToValue={(option, value) => String(option.id) === String(value?.id)}
                                                                                        value={this.state.editingItem?._uomObj}
                                                                                        onChange={(event, newValue) => {
                                                                                            this.updateEditField('uom', newValue);
                                                                                        }}
                                                                                        filterOptions={(options, params) => {
                                                                                            const filtered = options.filter(opt =>
                                                                                                opt.name.toLowerCase().includes(params.inputValue.toLowerCase())
                                                                                            );
                                                                                            if (appmasterid === "2" || appmasterid === "3") {
                                                                                                filtered.unshift({
                                                                                                    inputValue: 'add-new',
                                                                                                    name: '+ Add New UOM',
                                                                                                });
                                                                                            }
                                                                                            return filtered;
                                                                                        }}
                                                                                        renderOption={(props, option) => {
                                                                                            const isAddNew = option.inputValue === 'add-new';
                                                                                            return (
                                                                                                <li
                                                                                                    {...props}
                                                                                                    style={{
                                                                                                        fontWeight: isAddNew ? 'bold' : 'normal',
                                                                                                        color: isAddNew ? '#4d4d4d' : 'inherit',
                                                                                                        transition: 'transform 0.01s ease',
                                                                                                        fontSize: '0.8rem'
                                                                                                    }}
                                                                                                >
                                                                                                    {option.name}
                                                                                                </li>
                                                                                            );
                                                                                        }}
                                                                                        renderInput={(params) => (
                                                                                            <div ref={params.InputProps.ref}>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    {...params.inputProps}
                                                                                                    className="UI-input"
                                                                                                    style={{ width: '100%', fontSize: '0.8rem', padding: '4px' }}
                                                                                                    placeholder="UOM"
                                                                                                />
                                                                                            </div>
                                                                                        )}
                                                                                        size="small"
                                                                                    />
                                                                                </td>
                                                                                <td className="UI-td">
                                                                                    <Autocomplete
                                                                                        options={this.state.brandsList}
                                                                                        getOptionLabel={(option) => option.brand || ''}
                                                                                        isOptionEqualToValue={(option, value) => String(option.id) === String(value?.id)}
                                                                                        value={this.state.editingItem?._brandObj}
                                                                                        onChange={(event, newValue) => {
                                                                                            this.updateEditField('brand', newValue);
                                                                                        }}
                                                                                        filterOptions={(options, params) => {
                                                                                            const filtered = options.filter(opt =>
                                                                                                opt.brand.toLowerCase().includes(params.inputValue.toLowerCase())
                                                                                            );
                                                                                            if (appmasterid === "2" || appmasterid === "3") {
                                                                                                filtered.unshift({
                                                                                                    inputValue: 'add-new',
                                                                                                    brand: '+ Add New Brand',
                                                                                                });
                                                                                            }
                                                                                            return filtered;
                                                                                        }}
                                                                                        renderOption={(props, option) => {
                                                                                            const isAddNew = option.inputValue === 'add-new';
                                                                                            return (
                                                                                                <li
                                                                                                    {...props}
                                                                                                    style={{
                                                                                                        fontWeight: isAddNew ? 'bold' : 'normal',
                                                                                                        color: isAddNew ? '#4d4d4d' : 'inherit',
                                                                                                        transition: 'transform 0.01s ease',
                                                                                                        fontSize: '0.8rem'
                                                                                                    }}
                                                                                                >
                                                                                                    {option.brand}
                                                                                                </li>
                                                                                            );
                                                                                        }}
                                                                                        renderInput={(params) => (
                                                                                            <div ref={params.InputProps.ref}>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    {...params.inputProps}
                                                                                                    className="UI-input"
                                                                                                    style={{ width: '100%', fontSize: '0.8rem', padding: '4px' }}
                                                                                                    placeholder="Brand"
                                                                                                />
                                                                                            </div>
                                                                                        )}
                                                                                        size="small"
                                                                                    />
                                                                                </td>
                                                                                <td className="UI-td">
                                                                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                                                        <SelectableRadio
                                                                                            checked={this.state.editingItem?.parameters || false}
                                                                                            onClick={() =>
                                                                                                this.updateEditField("parameters", !this.state.editingItem?.parameters)
                                                                                            }
                                                                                            size="sm"
                                                                                        />
                                                                                    </div>
                                                                                </td>
                                                                                <td className="UI-td">
                                                                                    <textarea
                                                                                        value={this.state.editingItem?.description || ''}
                                                                                        onChange={(e) => this.updateEditField('description', e.target.value)}
                                                                                        className={`UI-input ${hasErrors && hasErrors.includes('Description is required') ? 'UI-input-error' : ''}`}
                                                                                        style={{ width: '100%', fontSize: '0.8rem', padding: '4px', minHeight: '40px' }}
                                                                                    />
                                                                                </td>
                                                                                <td className="UI-td">
                                                                                    <div style={{ display: 'flex', gap: '8px' }}>
                                                                                        {this.state.bulkEditItemId === item.id ? (
                                                                                            <>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    onClick={this.saveEditItem}
                                                                                                    className="UI-btn UI-btn-success"
                                                                                                    style={{ fontSize: '0.7rem', padding: '3px 6px' }}
                                                                                                >
                                                                                                    Save
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    onClick={this.cancelEditItem}
                                                                                                    className="UI-btn UI-btn-outline"
                                                                                                    style={{ fontSize: '0.7rem', padding: '3px 6px' }}
                                                                                                >
                                                                                                    Cancel
                                                                                                </button>
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    onClick={() => this.startEditItem(item)}
                                                                                                    className="UI-delete-button-list"
                                                                                                    onMouseEnter={() => this.setState({ hovered: `edit-${item.id}` })}
                                                                                                    onMouseLeave={() => this.setState({ hovered: null })}
                                                                                                >
                                                                                                    <Tooltip title="Edit" arrow
                                                                                                        slotProps={{
                                                                                                            popper: {
                                                                                                                sx: { pointerEvents: 'none' },
                                                                                                            },
                                                                                                        }}>
                                                                                                        <img
                                                                                                            src={EditIcon}
                                                                                                            alt="Edit"
                                                                                                            className={`UI-edit-icon ${this.state.hovered === `edit-${item.id}` ? 'UI-edit-icon-hover' : ''}`}
                                                                                                            style={{ width: '16px', height: '16px' }}
                                                                                                        />
                                                                                                    </Tooltip>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    onClick={() => this.Removeitem(item.id)}
                                                                                                    className="UI-delete-button-list"
                                                                                                    onMouseEnter={() => this.setState({ hovered: `delete-${item.id}` })}
                                                                                                    onMouseLeave={() => this.setState({ hovered: null })}
                                                                                                >
                                                                                                    <Tooltip title="Delete" arrow
                                                                                                        slotProps={{
                                                                                                            popper: {
                                                                                                                sx: { pointerEvents: 'none' },
                                                                                                            },
                                                                                                        }}>
                                                                                                        <img
                                                                                                            src={DeleteIcon}
                                                                                                            alt="Delete"
                                                                                                            className={`UI-delete-icon ${this.state.hovered === `delete-${item.id}` ? 'UI-delete-icon-hover' : ''}`}
                                                                                                            style={{ width: '16px', height: '16px' }}
                                                                                                        />
                                                                                                    </Tooltip>
                                                                                                </button>
                                                                                            </>
                                                                                        )}
                                                                                    </div>
                                                                                </td>
                                                                            </>
                                                                        ) : (
                                                                            // View Mode - WITH LIVE PARAMETER TOGGLE
                                                                            <>
                                                                                <td className="UI-td">
                                                                                    <div>
                                                                                        {item.name || <span style={{ color: '#dc2626' }}>-</span>}
                                                                                    </div>
                                                                                </td>
                                                                                <td className="UI-td">
                                                                                    <span className="UI-badge" style={{
                                                                                        backgroundColor: isDuplicate ? '#fee2e2' : (hasErrors ? '#fef3c7' : '#dbeafe'),
                                                                                        color: isDuplicate ? '#dc2626' : (hasErrors ? '#92400e' : '#1976d2')
                                                                                    }}>
                                                                                        {item.itemcode || <span style={{ color: '#dc2626' }}>-</span>}
                                                                                    </span>
                                                                                </td>
                                                                                {ccountry === "India" && <td className="UI-td">{item.hsn || '-'}</td>}
                                                                                <td className="UI-td">{item.tax || '0'}%</td>
                                                                                <td className="UI-td">{item.model || '-'}</td>
                                                                                <td className="UI-td">
                                                                                    {item.mcategory ? item.mcategory :
                                                                                        this.state.bulkFieldMappings.mcategory ?
                                                                                            <span style={{ fontStyle: 'italic', color: '#64748b' }} title="From Bulk Mapping">{this.state.bulkFieldMappings.mcategory}*</span> :
                                                                                            <span style={{ color: '#dc2626' }}>-</span>
                                                                                    }
                                                                                </td>
                                                                                <td className="UI-td">
                                                                                    {item.category2 ? item.category2 :
                                                                                        this.state.bulkFieldMappings.category2 ?
                                                                                            <span style={{ fontStyle: 'italic', color: '#64748b' }} title="From Bulk Mapping">{this.state.bulkFieldMappings.category2}*</span> :
                                                                                            '-'
                                                                                    }
                                                                                </td>
                                                                                <td className="UI-td">
                                                                                    {item.category ? item.category :
                                                                                        this.state.bulkFieldMappings.category ?
                                                                                            <span style={{ fontStyle: 'italic', color: '#64748b' }} title="From Bulk Mapping">{this.state.bulkFieldMappings.category}*</span> :
                                                                                            '-'
                                                                                    }
                                                                                </td>
                                                                                <td className="UI-td">
                                                                                    {item.uom ? item.uom :
                                                                                        this.state.bulkFieldMappings.uom ?
                                                                                            <span style={{ fontStyle: 'italic', color: '#64748b' }} title="From Bulk Mapping">{this.state.bulkFieldMappings.uom}*</span> :
                                                                                            <span style={{ color: '#dc2626' }}>-</span>
                                                                                    }
                                                                                </td>
                                                                                <td className="UI-td">
                                                                                    {item.brand ? item.brand :
                                                                                        this.state.bulkFieldMappings.brand ?
                                                                                            <span style={{ fontStyle: 'italic', color: '#64748b' }} title="From Bulk Mapping">{this.state.bulkFieldMappings.brand}*</span> :
                                                                                            '-'
                                                                                    }
                                                                                </td>
                                                                                <td className="UI-td">
                                                                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                                                        <SelectableRadio
                                                                                            checked={item.parameters || (item.parameters === undefined && this.state.bulkFieldMappings.parameters) || false}
                                                                                            onClick={() => {
                                                                                                if (this.state.bulkEditItemId) return;

                                                                                                const updatedItems = this.state.itemslist.map(i => {
                                                                                                    if (i.id === item.id) {
                                                                                                        const manualFields = { ...(i.manualFields || {}), parameters: true };
                                                                                                        return { ...i, parameters: !i.parameters, manualFields };
                                                                                                    }
                                                                                                    return i;
                                                                                                });

                                                                                                const updatedFiles = this.state.uploadedFiles.map(file => ({
                                                                                                    ...file,
                                                                                                    items: file.items.map(i => {
                                                                                                        if (i.id === item.id) {
                                                                                                            const manualFields = { ...(i.manualFields || {}), parameters: true };
                                                                                                            return { ...i, parameters: !i.parameters, manualFields };
                                                                                                        }
                                                                                                        return i;
                                                                                                    })
                                                                                                }));

                                                                                                this.setState({
                                                                                                    itemslist: updatedItems,
                                                                                                    uploadedFiles: updatedFiles
                                                                                                }, () => {
                                                                                                    this.validateBulkItems();
                                                                                                });
                                                                                            }}
                                                                                            size="sm"
                                                                                        />
                                                                                    </div>
                                                                                </td>
                                                                                <td className="UI-td" style={{ color: !item.description ? '#dc2626' : 'inherit' }}>
                                                                                    <Tooltip title={item.description || ''} arrow
                                                                                        slotProps={{
                                                                                            popper: {
                                                                                                sx: { pointerEvents: 'none' },
                                                                                            },
                                                                                        }}>
                                                                                        <span>
                                                                                            {item.description?.substring(0, 30) || <span style={{ color: '#dc2626' }}>-</span>}
                                                                                            {item.description?.length > 30 && '...'}
                                                                                        </span>
                                                                                    </Tooltip>
                                                                                </td>
                                                                                <td className="UI-td">
                                                                                    <div style={{ display: 'flex', gap: '8px' }}>
                                                                                        {this.state.bulkEditItemId === item.id ? (
                                                                                            <>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    onClick={this.saveEditItem}
                                                                                                    className="UI-btn UI-btn-success"
                                                                                                    style={{ fontSize: '0.7rem', padding: '3px 6px' }}
                                                                                                >
                                                                                                    Save
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    onClick={this.cancelEditItem}
                                                                                                    className="UI-btn UI-btn-outline"
                                                                                                    style={{ fontSize: '0.7rem', padding: '3px 6px' }}
                                                                                                >
                                                                                                    Cancel
                                                                                                </button>
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    onClick={() => this.startEditItem(item)}
                                                                                                    className="UI-delete-button-list"
                                                                                                    onMouseEnter={() => this.setState({ hovered: `edit-${item.id}` })}
                                                                                                    onMouseLeave={() => this.setState({ hovered: null })}
                                                                                                >
                                                                                                    <Tooltip title="Edit" arrow
                                                                                                        slotProps={{
                                                                                                            popper: {
                                                                                                                sx: { pointerEvents: 'none' },
                                                                                                            },
                                                                                                        }}>
                                                                                                        <img
                                                                                                            src={EditIcon}
                                                                                                            alt="Edit"
                                                                                                            className={`UI-edit-icon ${this.state.hovered === `edit-${item.id}` ? 'UI-edit-icon-hover' : ''}`}
                                                                                                            style={{ width: '16px', height: '16px' }}
                                                                                                        />
                                                                                                    </Tooltip>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    onClick={() => this.Removeitem(item.id)}
                                                                                                    className="UI-delete-button-list"
                                                                                                    onMouseEnter={() => this.setState({ hovered: `delete-${item.id}` })}
                                                                                                    onMouseLeave={() => this.setState({ hovered: null })}
                                                                                                >
                                                                                                    <Tooltip title="Delete" arrow
                                                                                                        slotProps={{
                                                                                                            popper: {
                                                                                                                sx: { pointerEvents: 'none' },
                                                                                                            },
                                                                                                        }}>
                                                                                                        <img
                                                                                                            src={DeleteIcon}
                                                                                                            alt="Delete"
                                                                                                            className={`UI-delete-icon ${this.state.hovered === `delete-${item.id}` ? 'UI-delete-icon-hover' : ''}`}
                                                                                                            style={{ width: '16px', height: '16px' }}
                                                                                                        />
                                                                                                    </Tooltip>
                                                                                                </button>
                                                                                            </>
                                                                                        )}
                                                                                    </div>
                                                                                </td>
                                                                            </>
                                                                        )}
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                    {/* Truncation message removed to show all items */}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                )}

                                {/* Action Buttons - updated for bulk */}
                                {(this.state.entrytype === 'manual' || this.state.itemslist.length > 0) && (
                                    <div className="UI-btn-actions">
                                        <button
                                            type="button"
                                            onClick={this.handleCancel}
                                            className={`UI-btn UI-btn-outline`}
                                        >
                                            Cancel
                                        </button>

                                        {this.state.iseditable && (
                                            <button
                                                type="submit"
                                                disabled={this.state.loader || (this.state.entrytype === 'bulk' && this.state.itemslist.length === 0)}
                                                className={`UI-btn UI-btn-primary `}
                                            >
                                                {this.state.loader
                                                    ? 'Processing...'
                                                    : (id < 1
                                                        ? (this.state.entrytype === 'manual'
                                                            ? 'Submit'
                                                            : `Confirm ${selectedCount > 0 ? selectedCount : totalItems} Items`)
                                                        : 'Update Item')}
                                            </button>
                                        )}
                                    </div>
                                )}
                            </form>
                        </div>
                    </div>
                </div >

                {/* Add New Main Category Dialog */}
                < Dialog
                    open={this.state.addNewDialogOpen}
                    onClose={() => this.setState({ addNewDialogOpen: false })
                    }
                    maxWidth="sm"
                    fullWidth
                    PaperProps={{
                        style: {
                            borderRadius: 8,
                            padding: 0,
                            backgroundColor: '#ffffff',
                        },
                    }}
                >
                    <DialogTitle className="UI-title-subTitle tw-border-b " style={{ padding: '16px 24px 5px 24px' }}>
                        Add New Product Category
                    </DialogTitle>

                    <DialogContent style={{ paddingTop: "16px" }}>
                        <div className="UI-form-section !tw-mb-0" >
                            <div className="UI-form-group">
                                <TextfieldComponent
                                    type="text"
                                    label="Main Category"
                                    value={this.state.newMainCategory}
                                    onChange={(e) =>
                                        this.setState({ newMainCategory: e.target.value, addNewMessage: "" })
                                    }
                                    className={`UI-input ${this.state.addNewMessage ? 'UI-input-error' : ''}`}
                                    placeholder="Enter main category"
                                    autoFocus
                                    required
                                    error={this.state.addNewMessage}
                                />
                            </div>

                            <div className="UI-form-group">
                                <TextfieldComponent
                                    type="text"
                                    label="Sub Category (optional)"
                                    value={this.state.newSubCategory}
                                    onChange={(e) =>
                                        this.setState({ newSubCategory: e.target.value, addNewMessage: "" })
                                    }
                                    className="UI-input"
                                    placeholder="Enter sub category"
                                />
                            </div>

                            <div className="UI-form-group">
                                <TextfieldComponent
                                    type="text"
                                    label="Category Level 3 (optional)"
                                    value={this.state.newCategoryName}
                                    onChange={(e) =>
                                        this.setState({ newCategoryName: e.target.value, addNewMessage: "" })
                                    }
                                    className="UI-input"
                                    placeholder="Enter category level 3"
                                />
                            </div>
                        </div>
                    </DialogContent>

                    <DialogActions style={{ padding: "16px 24px" }} className="tw-border-t">
                        <button
                            type="button"
                            onClick={() => this.setState({ addNewDialogOpen: false })}
                            disabled={this.state.saveLoading}
                            className={`UI-btn UI-btn-outline`}
                        >
                            Cancel
                        </button>

                        <button
                            type="button"
                            onClick={this.submitNewCategory}
                            disabled={
                                this.state.saveLoading ||
                                !(this.state.newMainCategory && this.state.newMainCategory.trim())
                            }
                            className={`UI-btn UI-btn-primary`}
                        >
                            {this.state.saveLoading ? "Saving..." : "Save"}
                        </button>
                    </DialogActions>
                </Dialog >

                {/* Add New Sub Category Dialog */}
                < Dialog
                    open={this.state.addNewDialogOpenSub}
                    onClose={() => this.setState({ addNewDialogOpenSub: false })}
                    maxWidth="sm"
                    fullWidth
                    PaperProps={{
                        style: {
                            borderRadius: 8,
                            padding: 0,
                            backgroundColor: '#ffffff',
                        },
                    }}
                >
                    <DialogTitle className="UI-title-subTitle tw-border-b" style={{ padding: '16px 24px 5px 24px' }}>
                        Add New Sub Category
                    </DialogTitle>

                    <DialogContent style={{ paddingTop: "16px" }}>
                        <div className="UI-form-section !tw-mb-0">
                            <div className="UI-form-group">
                                <TextfieldComponent
                                    type="text"
                                    value={this.state.dialogParentMainCategory}
                                    label="Main Category"
                                    disabled
                                />
                            </div>

                            <div className="UI-form-group">
                                <TextfieldComponent
                                    type="text"
                                    value={this.state.newSubCategory}
                                    label="Sub Category"
                                    onChange={(e) =>
                                        this.setState({ newSubCategory: e.target.value, addNewMessageSub: "" })
                                    }
                                    className={`UI-input ${this.state.addNewMessageSub ? 'UI-input-error' : ''}`}
                                    placeholder="Enter sub category"
                                    autoFocus
                                    required
                                    error={this.state.addNewMessageSub}
                                />
                            </div>

                            <div className="UI-form-group">
                                <TextfieldComponent
                                    type="text"
                                    label="Category Level 3 (optional)"
                                    value={this.state.newCategoryName}
                                    onChange={(e) =>
                                        this.setState({ newCategoryName: e.target.value, addNewMessageSub: "" })
                                    }
                                    className="UI-input"
                                    placeholder="Enter category level 3"
                                />
                            </div>
                        </div>
                    </DialogContent>

                    <DialogActions style={{ padding: "16px 24px" }} className="tw-border-t">
                        <button
                            type="button"
                            onClick={() => this.setState({ addNewDialogOpenSub: false })}
                            disabled={this.state.saveLoadingSub}
                            className={`UI-btn UI-btn-outline`}
                        >
                            Cancel
                        </button>

                        <button
                            type="button"
                            onClick={this.submitNewSubCategory}
                            disabled={
                                this.state.saveLoadingSub ||
                                !(this.state.newSubCategory && this.state.newSubCategory.trim())
                            }
                            className={`UI-btn UI-btn-primary`}
                        >
                            {this.state.saveLoadingSub ? "Saving..." : "Save"}
                        </button>
                    </DialogActions>
                </Dialog >

                {/* Add New Category Level 3 Dialog */}
                < Dialog
                    open={this.state.addNewDialogOpenLevel3}
                    onClose={() => this.setState({ addNewDialogOpenLevel3: false })}
                    maxWidth="sm"
                    fullWidth
                    PaperProps={{
                        style: {
                            borderRadius: 8,
                            padding: 0,
                            backgroundColor: '#ffffff',
                        },
                    }}
                >
                    <DialogTitle className="UI-title-subTitle tw-border-b " style={{ padding: '16px 24px 5px 24px' }}>
                        Add New Category Level 3
                    </DialogTitle>

                    <DialogContent style={{ paddingTop: "16px" }}>
                        <div className="UI-form-section !tw-mb-0">
                            <div className="UI-form-group">
                                <TextfieldComponent
                                    type="text"
                                    label="Main Category"
                                    value={this.state.dialogParentMainCategory}
                                    className="UI-input UI-input-disabled"
                                    disabled
                                />
                            </div>

                            <div className="UI-form-group">
                                <TextfieldComponent
                                    type="text"
                                    label="Sub Category"
                                    value={this.state.dialogParentSubCategory}
                                    className="UI-input UI-input-disabled"
                                    disabled
                                />
                            </div>

                            <div className="UI-form-group">
                                <TextfieldComponent
                                    type="text"
                                    label="Category Level 3"
                                    value={this.state.newCategoryName}
                                    onChange={(e) =>
                                        this.setState({ newCategoryName: e.target.value, addNewMessageLevel3: "" })
                                    }
                                    className={`UI-input ${this.state.addNewMessageLevel3 ? 'UI-input-error' : ''}`}
                                    placeholder="Enter category level 3"
                                    autoFocus
                                    required
                                    error={this.state.addNewMessageLevel3}
                                />
                            </div>
                        </div>
                    </DialogContent>

                    <DialogActions style={{ padding: "16px 24px" }} className="tw-border-t">
                        <button
                            type="button"
                            onClick={() => this.setState({ addNewDialogOpenLevel3: false })}
                            disabled={this.state.saveLoadingLevel3}
                            className={`UI-btn UI-btn-outline`}
                        >
                            Cancel
                        </button>

                        <button
                            type="button"
                            onClick={this.submitNewCategoryLevel3}
                            disabled={
                                this.state.saveLoadingLevel3 ||
                                !(this.state.newCategoryName && this.state.newCategoryName.trim())
                            }
                            className={`UI-btn UI-btn-primary`}
                        >
                            {this.state.saveLoadingLevel3 ? "Saving..." : "Save"}
                        </button>
                    </DialogActions>
                </Dialog >

                {/* Add New Brand Dialog */}
                <Dialog
                    open={this.state.addNewBrandDialogOpen}
                    onClose={() => this.setState({ addNewBrandDialogOpen: false })}
                    maxWidth="sm"
                    fullWidth
                    PaperProps={{
                        style: {
                            borderRadius: 8,
                            padding: 0,
                            backgroundColor: '#ffffff',
                        },
                    }}
                >
                    <DialogTitle className="UI-title-subTitle tw-border-b" style={{ padding: '16px 24px 5px 24px' }}>
                        Add New Brand
                    </DialogTitle>
                    <DialogContent style={{ paddingTop: "10px" }}>
                        <div className="UI-form-section !tw-mb-0">
                            <div className="UI-form-group">
                                <TextfieldComponent
                                    type="text"
                                    label="Brand Name"
                                    value={this.state.newBrandName}
                                    onChange={(e) =>
                                        this.setState({ newBrandName: e.target.value, addNewMessageBrand: "" })
                                    }
                                    placeholder="Enter brand name"
                                    autoFocus
                                    required
                                    error={this.state.addNewMessageBrand}
                                />
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions style={{ padding: "16px 24px" }} className="tw-border-t">
                        <button
                            type="button"
                            onClick={() => this.setState({ addNewBrandDialogOpen: false })}
                            disabled={this.state.saveLoadingBrand}
                            className={`UI-btn UI-btn-outline`}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={this.submitNewBrand}
                            disabled={
                                this.state.saveLoadingBrand ||
                                !(this.state.newBrandName && this.state.newBrandName.trim())
                            }
                            className={`UI-btn UI-btn-primary`}
                        >
                            {this.state.saveLoadingBrand ? "Saving..." : "Save"}
                        </button>
                    </DialogActions>
                </Dialog>

                {/* Add New UOM Dialog */}
                <Dialog
                    open={this.state.addNewUomDialogOpen}
                    onClose={() => this.setState({ addNewUomDialogOpen: false })}
                    maxWidth="sm"
                    fullWidth
                    PaperProps={{
                        style: {
                            borderRadius: 8,
                            padding: 0,
                            backgroundColor: '#ffffff',
                        },
                    }}
                >
                    <DialogTitle className="UI-title-subTitle tw-border-b" style={{ padding: '16px 24px 5px 24px' }}>
                        Add New UOM
                    </DialogTitle>
                    <DialogContent style={{ paddingTop: "10px" }}>
                        <div className="UI-form-section !tw-mb-0">
                            <div className="UI-form-group">
                                <TextfieldComponent
                                    type="text"
                                    label="UOM"
                                    value={this.state.newUomName}
                                    onChange={(e) =>
                                        this.setState({ newUomName: e.target.value, addNewMessageUom: "" })
                                    }
                                    placeholder="Enter UOM (e.g., KGS, PCS)"
                                    autoFocus
                                    required
                                    error={this.state.addNewMessageUom}
                                />
                            </div>
                            <div className="UI-form-group">
                                <TextfieldComponent
                                    type="text"
                                    label="Description (optional)"
                                    value={this.state.newUomDescription}
                                    onChange={(e) =>
                                        this.setState({ newUomDescription: e.target.value })
                                    }
                                    placeholder="Enter UOM description (e.g., Kilograms, Pieces)"
                                />
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions style={{ padding: "16px 24px" }} className="tw-border-t">
                        <button
                            type="button"
                            onClick={() => this.setState({ addNewUomDialogOpen: false })}
                            disabled={this.state.saveLoadingUom}
                            className={`UI-btn UI-btn-outline`}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={this.submitNewUom}
                            disabled={
                                this.state.saveLoadingUom ||
                                !(this.state.newUomName && this.state.newUomName.trim())
                            }
                            className={`UI-btn UI-btn-primary`}
                        >
                            {this.state.saveLoadingUom ? "Saving..." : "Save"}
                        </button>
                    </DialogActions>
                </Dialog>
            </div >
        );
    }
}

export default withRouter(NewItem);